import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { timer } from "rxjs";
import { LocalstorageService, UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { BusModifyComponent } from "../bus-maintenance/bus-maintenance-bus-table/bus-modify/bus-modify.component";
import { GMap } from "../bus-tracker-main-map/shared/gmap";
import { BTBusGetPersonPhotosRequest } from "./shared/BTBusGetPersonPhotosRequest";
import { DataService_BusTrackerBusHistory } from "./shared/data.service";
import { DateRequest } from "./shared/DateRequest";
import * as moment from "moment";

@Component({
	selector: "app-bus-tracker-bus-history",
	templateUrl: "./bus-tracker-bus-history.component.html",
	styleUrls: ["./bus-tracker-bus-history.component.css"],
})
export class BusTrackerBusHistoryComponent implements OnInit {
	constructor(
		private userService: UserService,
		private schoolService: SchoolService,
		private localService: LocalstorageService,
		private busService: DataService_BusTrackerBusHistory
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.SpeedOption = this.lstSpeedOption[2];

		this.loadSchools();
	}

	ngOnDestory() {
		this.TimePlayer.unsubscribe();
		this.UpdatePreferences();
	}

	@HostListener("window:keydown", ["$event"])
	LogKeys(e: KeyboardEvent) {
		// ESC or Delete = Pause
		if (e.keyCode === 27 || e.keyCode === 46) {
			this.onPause();
			this.StudentUnSpiderfy();
		}
		// Enter = Toggle
		else if (e.keyCode == 13) {
			if (this.IsPlaying == false) {
				this.onPlay();
			} else if (this.IsPlaying == true) {
				this.onPause();
			}
		}
		//Z Reverse, X Forward
		else if (e.key == "z") {
			this.ReverseSeconds(this.SecondsPerInterval);
		} else if (e.key == "x") {
			this.AdvanceSeconds(this.SecondsPerInterval);
		}
	}

	//////////////////////////////////////////////////////////////////////
	//#region Data
	//////////////////////////////////////////////////////////////////////

	//////////////////////////////
	//#region Top Bar Options
	//////////////////////////////

	StartDate: Date = new Date();
	EndDate: Date = new Date();
	LastStartDate: Date = new Date();
	LastEndDate: Date = new Date();

	lstSchool: any = [];

	//Bus Positions
	ShowBusLocation: boolean = true;
	ShowKnownLocations: boolean = false;
	ShowAccuracyColor: boolean = false;
	AccuracyFt: number = 330;
	ShowBusPath: boolean = false;
	HideUnselected: boolean = false;
	CenterOnSelected: boolean = true;
	BusSchoolOptionID: any = 0;
	lstBusSchoolOption: any = [
		{
			ID: 0,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "My Schools Only",
		},
		{
			ID: 2,
			Desc: "Selected School Only",
		},
	];
	BusSchoolID: any = -1;
	BusSchool: any = null;
	BusSeverityOption: any = 0;
	lstSeverity: any = [
		{
			ID: 0,
			Desc: "All",
		},
		{
			ID: -1,
			Desc: "Has an Alert",
		},
		{
			ID: -2,
			Desc: "No Alerts",
		},
		{
			ID: 3,
			Desc: "Low",
		},
		{
			ID: 2,
			Desc: "Medium",
		},
		{
			ID: 1,
			Desc: "High",
		},
		{
			ID: -3,
			Desc: "Speed Warning",
		},
	];

	//Student Positions
	ShowStudentsSwipeOn: boolean = true;
	ShowStudentSwipeOff: boolean = true;
	StudentSchoolOptionID: any = 0;
	lstStudentSchoolOption: any = [
		{
			ID: 0,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "My Schools Only",
		},
		{
			ID: 2,
			Desc: "Selected School Only",
		},
	];
	StudentSchoolID: any = -1;
	StudentSchool: any = null;

	//Geo Fences
	ShowGeoFences: boolean = false;
	HideInactiveGeoFences: boolean = true;

	//Bus Labels
	BusShowBusNbr: boolean = true;
	BusShowBusDriver: boolean = false;
	BusShowCurrentRoute: boolean = false;
	BusShowRouteType: boolean = false;
	BusShowAlertDesc: boolean = true;
	BusTextColor: string = "#000000";
	DefaultBusTextColor: string = "#000000";

	//Location Labels
	KnownLocationShowBusNbr: boolean = false;
	KnownLocationShowCDate: boolean = false;
	KnownLocationShowSpeed: boolean = false;
	KnownLocationShowLatLong: boolean = false;
	KnownLocationShowDriver: boolean = false;
	LocationTextColor: string = "#000000";
	DefaultLocationTextColor: string = "#000000";

	//Student Labels
	ShowStudentName: boolean = true;
	ShowStudentID: boolean = false;
	ShowStudentBus: boolean = false;
	ShowStudentScanTime: boolean = false;
	ShowScheduledRider: boolean = false;
	StudentTextColor: string = "#0000FF";
	DefaultStudentTextColor: string = "#0000FF";

	//Current Time
	CurrentDT: Date = new Date();
	CurrentTimeInt: number = new Date().getTime();
	MinTime: number = new Date().getTime();
	MaxTime: number = new Date().getTime();

	ShowSideBar: boolean = false;

	ShowInfo: boolean = false;

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Lists of Data
	//////////////////////////////

	lstGeoFence: any = [];
	lstBusHistory: any = [];

	lstSelectedBuses: any = [];
	BusesFromSelector: any = [];
	lstSelectedStudents: any = [];
	StudentsFromSelector: any = [];
	// lstSelectedLocations: any = [];

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Map General
	//////////////////////////////

	ShowMap: boolean = false;
	overlays: any[] = [];
	options: any;
	MapPrefs: any;

	user: any;

	@ViewChild(GMap)
	mapRef: GMap;

	InitStylesAndListeners: any = false;

	RouteColorMaxSum: any = 384;
	lstRouteColors: string[] = [];

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Loading
	//////////////////////////////

	Processing: boolean = false;
	PrefLoading: boolean = true;
	HistoryLoading: boolean = false;

	LoadingBarWidth: string = "0%";
	LoadingBarTimeSeconds: number = 30;

	LoadingBarProgress: number = 0;
	LoadingBarStep: number = 0.1;
	LoadingBarPlayer: any;
	LoadingBarTimer: any;

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Time Player
	//////////////////////////////
	IsPlaying: boolean = false;
	TimePlayer: any;
	TimePlayerTimer: any;
	TimerIntervalSeconds: any = 0.1; //How often to update time
	SecondsPerInterval: any = 6; //How many seconds to add to current time

	SpeedOption: any;
	lstSpeedOption: any = [
		{
			ID: 0,
			Desc: "Very Slow",
			SecondsPerInterval: 0.06,
		},
		{
			ID: 1,
			Desc: "Slow",
			SecondsPerInterval: 0.6,
		},
		{
			ID: 2,
			Desc: "Normal",
			SecondsPerInterval: 6,
		},
		{
			ID: 3,
			Desc: "Fast",
			SecondsPerInterval: 60,
		},
		{
			ID: 4,
			Desc: "Very Fast",
			SecondsPerInterval: 600,
		},
	];

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Spiderfy (for Students)
	//////////////////////////////

	Tolerance: any = 35;
	SpiderMaxLegs: any = 10; //10;
	SpiderLegLength: any = 0.01;
	ZoomCoefficient: any = 0.0000001; //0.1;
	lstSpiderOverlays: any = [];
	SpiderfyBusStudentRideTxnID = -1;
	lstOverlaps = [];

	//#endregion
	//////////////////////////////

	//////////////////////////////
	//#region Sounds
	//////////////////////////////
	audio: any = new Audio();

	PlaySounds: boolean = false;
	Forwards: any = true; //Replaying sound
	AccidentHighSound: any = null;
	HighSeveritySound: any = null;
	MediumSeveritySound: any = null;
	LowSeveritySound: any = null;
	//#endregion
	//////////////////////////////

	//#endregion
	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	//#region Load Data
	//////////////////////////////////////////////////////////////////////

	loadSchools() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				if (this.lstSchool.length > 0) {
					this.BusSchoolID = this.lstSchool[0].SchoolID;
					this.BusSchool = this.lstSchool[0];

					this.StudentSchoolID = this.lstSchool[0].SchoolID;
					this.StudentSchool = this.lstSchool[0];
				}

				this.loadSounds();
			},
			(error) => {}
		);
	}

	loadSounds() {
		var result = this.busService.BusTrackerMapSoundsSelect();
		result.subscribe(
			(response) => {
				var data: any = response;

				if (data.length > 0) {
					data = data[0];
				}

				this.AccidentHighSound = window.URL.createObjectURL(this.dataURIToMP3Blob(data.AccidentHighSound));
				this.HighSeveritySound = window.URL.createObjectURL(this.dataURIToMP3Blob(data.HighSeveritySound));
				this.MediumSeveritySound = window.URL.createObjectURL(this.dataURIToMP3Blob(data.MediumSeveritySound));
				this.LowSeveritySound = window.URL.createObjectURL(this.dataURIToMP3Blob(data.LowSeveritySound));

				this.loadPreferences();
			},
			(error) => {}
		);
	}

	//#region Init

	loadPreferences() {
		this.PrefLoading = true;

		var result = this.busService.BusMapPreferenceSelect(this.user.personID);
		result.subscribe(
			(response) => {
				this.MapPrefs = response[0];

				this.options = {
					center: {
						lat: Number(this.MapPrefs.DefaultLat),
						lng: Number(this.MapPrefs.DefaultLong),
					},
					zoom: Number(this.MapPrefs.DefaultZoom),
				};

				this.ShowMap = true;

				this.PrefLoading = false;

				this.loadTopBarOptions();
			},
			(error) => {
				this.PrefLoading = false;
			}
		);
	}

	loadTopBarOptions() {
		var BT_HistoryMapOptions = this.localService.getItem("BT_History_MapOptions");

		if (BT_HistoryMapOptions != undefined) {
			this.StartDate = BT_HistoryMapOptions.StartDate == undefined ? new Date() : new Date(BT_HistoryMapOptions.StartDate);
			this.EndDate = BT_HistoryMapOptions.EndDate == undefined ? new Date() : new Date(BT_HistoryMapOptions.EndDate);
			this.LastStartDate = BT_HistoryMapOptions.StartDate == undefined ? new Date() : new Date(BT_HistoryMapOptions.StartDate);
			this.LastEndDate = BT_HistoryMapOptions.EndDate == undefined ? new Date() : new Date(BT_HistoryMapOptions.EndDate);

			this.CurrentDT = this.StartDate;
			this.CurrentTimeInt = this.StartDate.getTime();
			this.MinTime = this.StartDate.getTime();
			this.MaxTime = this.EndDate.getTime();

			//Overlays
			this.ShowKnownLocations = BT_HistoryMapOptions.ShowKnownLocations == undefined ? false : BT_HistoryMapOptions.ShowKnownLocations;
			this.ShowAccuracyColor = BT_HistoryMapOptions.ShowAccuracyColor == undefined ? false : BT_HistoryMapOptions.ShowAccuracyColor;
			this.AccuracyFt =
				BT_HistoryMapOptions.AccuracyFt == undefined || isNaN(Number(BT_HistoryMapOptions.AccuracyFt)) == true
					? 330
					: Number(BT_HistoryMapOptions.AccuracyFt);
			this.ShowBusPath = BT_HistoryMapOptions.ShowBusPath == undefined ? false : BT_HistoryMapOptions.ShowBusPath;
			this.ShowBusLocation = BT_HistoryMapOptions.ShowBusLocation == undefined ? true : BT_HistoryMapOptions.ShowBusLocation;
			this.HideUnselected = BT_HistoryMapOptions.HideUnselected == undefined ? false : BT_HistoryMapOptions.HideUnselected;
			this.ShowStudentsSwipeOn = BT_HistoryMapOptions.ShowStudentsSwipeOn == undefined ? false : BT_HistoryMapOptions.ShowStudentsSwipeOn;
			this.ShowStudentSwipeOff = BT_HistoryMapOptions.ShowStudentSwipeOff == undefined ? false : BT_HistoryMapOptions.ShowStudentSwipeOff;
			this.ShowGeoFences = BT_HistoryMapOptions.ShowGeoFences == undefined ? true : BT_HistoryMapOptions.ShowGeoFences;
			this.HideInactiveGeoFences = BT_HistoryMapOptions.HideInactiveGeoFences == undefined ? true : BT_HistoryMapOptions.HideInactiveGeoFences;
			//Labels
			//KnownLocations
			this.KnownLocationShowBusNbr = BT_HistoryMapOptions.KnownLocationShowBusNbr == undefined ? false : BT_HistoryMapOptions.KnownLocationShowBusNbr;
			this.KnownLocationShowCDate = BT_HistoryMapOptions.KnownLocationShowCDate == undefined ? false : BT_HistoryMapOptions.KnownLocationShowCDate;
			this.KnownLocationShowSpeed = BT_HistoryMapOptions.KnownLocationShowSpeed == undefined ? false : BT_HistoryMapOptions.KnownLocationShowSpeed;
			this.KnownLocationShowLatLong = BT_HistoryMapOptions.KnownLocationShowLatLong == undefined ? false : BT_HistoryMapOptions.KnownLocationShowLatLong;
			this.KnownLocationShowDriver = BT_HistoryMapOptions.KnownLocationShowDriver == undefined ? false : BT_HistoryMapOptions.KnownLocationShowDriver;
			this.LocationTextColor =
				BT_HistoryMapOptions.LocationTextColor == undefined ? this.DefaultLocationTextColor : BT_HistoryMapOptions.LocationTextColor;
			//Bus
			this.BusShowBusNbr = BT_HistoryMapOptions.BusShowBusNbr == undefined ? true : BT_HistoryMapOptions.BusShowBusNbr;
			this.BusShowBusDriver = BT_HistoryMapOptions.BusShowBusDriver == undefined ? false : BT_HistoryMapOptions.BusShowBusDriver;
			this.BusShowCurrentRoute = BT_HistoryMapOptions.BusShowCurrentRoute == undefined ? false : BT_HistoryMapOptions.BusShowCurrentRoute;
			this.BusShowRouteType = BT_HistoryMapOptions.BusShowRouteType == undefined ? false : BT_HistoryMapOptions.BusShowRouteType;
			this.BusShowAlertDesc = BT_HistoryMapOptions.BusShowAlertDesc == undefined ? true : BT_HistoryMapOptions.BusShowAlertDesc;
			this.CenterOnSelected = BT_HistoryMapOptions.CenterOnSelected == undefined ? true : BT_HistoryMapOptions.CenterOnSelected;
			this.BusTextColor = BT_HistoryMapOptions.BusTextColor == undefined ? this.DefaultBusTextColor : BT_HistoryMapOptions.BusTextColor;
			//Students
			this.ShowStudentName = BT_HistoryMapOptions.ShowStudentName == undefined ? true : BT_HistoryMapOptions.ShowStudentName;
			this.ShowStudentID = BT_HistoryMapOptions.ShowStudentID == undefined ? false : BT_HistoryMapOptions.ShowStudentID;
			this.ShowStudentBus = BT_HistoryMapOptions.ShowStudentBus == undefined ? false : BT_HistoryMapOptions.ShowStudentBus;
			this.ShowStudentScanTime = BT_HistoryMapOptions.ShowStudentScanTime == undefined ? false : BT_HistoryMapOptions.ShowStudentScanTime;
			this.ShowScheduledRider = BT_HistoryMapOptions.ShowScheduledRider == undefined ? false : BT_HistoryMapOptions.ShowScheduledRider;
			this.StudentTextColor = BT_HistoryMapOptions.StudentTextColor == undefined ? this.DefaultStudentTextColor : BT_HistoryMapOptions.StudentTextColor;

			var SpeedOptionID = BT_HistoryMapOptions.SpeedOptionID == undefined ? 0 : BT_HistoryMapOptions.SpeedOptionID;
			this.SpeedOption = this.lstSpeedOption[SpeedOptionID];
			this.SecondsPerInterval =
				BT_HistoryMapOptions.SecondsPerInterval == undefined ? this.SpeedOption.SecondsPerInterval : BT_HistoryMapOptions.SecondsPerInterval;

			this.BusSchoolOptionID = BT_HistoryMapOptions.BusSchoolOptionID == undefined ? 0 : BT_HistoryMapOptions.BusSchoolOptionID;
			this.StudentSchoolOptionID = BT_HistoryMapOptions.StudentSchoolOptionID == undefined ? 0 : BT_HistoryMapOptions.StudentSchoolOptionID;
			this.BusSchoolID = BT_HistoryMapOptions.BusSchoolID == undefined ? 0 : BT_HistoryMapOptions.BusSchoolID;
			this.StudentSchoolID = BT_HistoryMapOptions.StudentSchoolID == undefined ? 0 : BT_HistoryMapOptions.StudentSchoolID;

			var BusSchoolFound: boolean = false;
			for (var z = 0; z < this.lstSchool.length; z++) {
				var next = this.lstSchool[z];

				if (next.SchoolID == this.BusSchoolID) {
					this.BusSchool = next;
					BusSchoolFound = true;
					break;
				}
			}

			if (!BusSchoolFound) {
				this.BusSchool = this.lstSchool[0];
				this.BusSchoolID = this.lstSchool[0].SchoolID;
			}

			var StudentSchoolFound: boolean = false;
			for (var z = 0; z < this.lstSchool.length; z++) {
				var next = this.lstSchool[z];

				if (next.SchoolID == this.StudentSchoolID) {
					this.StudentSchool = next;
					break;
				}
			}

			if (!StudentSchoolFound) {
				this.StudentSchool = this.lstSchool[0];
				this.StudentSchoolID = this.lstSchool[0].SchoolID;
			}

			this.BusSeverityOption = BT_HistoryMapOptions.BusSeverityOption == undefined ? 0 : BT_HistoryMapOptions.BusSeverityOption;
		}

		this.loadGeoFences(); //Only load once per page load (don't need to refresh every minute)
	}

	//#endregion

	//#region Load Data From DB

	loadGeoFences() {
		var result = this.busService.GeoFenceSelectList();
		result.subscribe(
			(response) => {
				this.lstGeoFence = response;
				this.DrawGeoFences();
				// this.loadBusHistory();
			},
			(error) => {}
		);
	}

	loadBusHistory() {
		if (this.IsPlaying == true) {
			this.onPause();
		}

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY HH:mm:00");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY HH:mm:00");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}

		this.LastStartDate = new Date(this.StartDate);
		this.LastEndDate = new Date(this.EndDate);

		try {
			this.MinTime = this.StartDate.getTime();
		} catch (e) {
			e.toString();
			this.MinTime = 0;
		}

		try {
			this.MaxTime = this.EndDate.getTime();
		} catch (e) {
			e.toString();
			this.MaxTime = 0;
		}

		this.HistoryLoading = true;
		this.StartLoadingBarAnimation();

		let parms: DateRequest = {
			StartDate: fsDate,
			EndDate: feDate,
			UserID: this.user.userID,
		};

		var result = this.busService.BusHistoryFullInfoSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstBusHistory = response;

				this.lstSelectedBuses = [];
				this.BusesFromSelector = [];
				this.lstSelectedStudents = [];
				this.StudentsFromSelector = [];

				for (var z = 0; z < this.lstBusHistory.length; z++) {
					var next = this.lstBusHistory[z];

					next.HistoryIndex = 0;
					next.PathIndex = 0;
					next.StudentIndex = 0;
					next.lstPaths = [];
					next.lstCurrentAlerts = [];
					next.HasAlert = false;
					next.Severity = 0;
					next.AlertDesc = "";
					next.StudentCount = next.lstStudentsOnBus.length;
				}

				this.InitColors();

				this.LoadingBarWidth = "100%";
				this.HistoryLoading = false;

				this.ClearAll();

				this.CurrentDT = new Date(this.StartDate);
				this.CurrentTimeInt = this.CurrentDT.getTime();

				// this.onNext();

				// this.DrawGeoFences();

				// this.UpdateOverlays();
			},
			(error) => {
				this.LoadingBarWidth = "100%";
				this.HistoryLoading = false;
			}
		);
	}

	StartLoadingBarAnimation(){
		this.LoadingBarProgress = 0;
		this.LoadingBarTimer = timer(0, this.LoadingBarStep * 1000);

		if (this.LoadingBarPlayer != undefined) {
			this.LoadingBarPlayer.unsubscribe();
		}

		this.LoadingBarPlayer = this.LoadingBarTimer.subscribe((val) => {
			this.LoadingBarProgress = (this.LoadingBarProgress + this.LoadingBarStep) % this.LoadingBarTimeSeconds;

			this.UpdateLoadingBarWidth();

			if(this.HistoryLoading == false){
				this.LoadingBarWidth = "100%";
				this.LoadingBarPlayer.unsubscribe();
			}
		});
	}

	UpdateLoadingBarWidth(){
		var frac = Number((this.LoadingBarProgress / this.LoadingBarTimeSeconds) * 100).toFixed(2);

		this.LoadingBarWidth = frac + "%";
	}

	//#endregion

	//#endregion
	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	//#region Buttons
	//////////////////////////////////////////////////////////////////////

	//#region Main
	onRefresh() {
		// this.CurrentDT = new Date(this.StartDate);
		// this.CurrentTimeInt = this.CurrentDT.getTime();

		this.loadBusHistory();
	}

	onPlay() {
		this.IsPlaying = true;
		this.Forwards = true;

		this.TimePlayerTimer = timer(0, this.TimerIntervalSeconds * 1000);

		if (this.TimePlayer != undefined) {
			this.TimePlayer.unsubscribe();
		}

		this.TimePlayer = this.TimePlayerTimer.subscribe((val) => {
			if (this.CurrentDT < this.EndDate) {
				this.AdvanceSeconds(this.SecondsPerInterval);
			} else {
				this.IsPlaying = false;
				this.TimePlayer.unsubscribe();
			}
		});
	}

	onPause() {
		this.IsPlaying = false;
		if (this.TimePlayer != undefined) {
			this.TimePlayer.unsubscribe();
		}
	}

	onSearch() {
		this.ShowSideBar = !this.ShowSideBar;
	}

	onDeselectAll() {
		this.lstSelectedBuses = [];
		this.BusesFromSelector = [];
		this.lstSelectedStudents = [];
		this.StudentsFromSelector = [];
		this.UpdateOverlays();
	}

	onToggleInfo() {
		this.ShowInfo = !this.ShowInfo;
	}

	onPlaySoundsClick() {
		this.PlaySounds = !this.PlaySounds;
	}

	//#endregion

	//#region Reset Buttons

	onResetBusLabelColor() {
		this.BusTextColor = this.DefaultBusTextColor;
	}

	onResetLocationLabelColor() {
		this.LocationTextColor = this.DefaultLocationTextColor;
	}

	onResetStudentLabelColor() {
		this.StudentTextColor = this.DefaultStudentTextColor;
	}

	//#endregion

	//#endregion
	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	//#region Events
	//////////////////////////////////////////////////////////////////////

	//#region Top Bar

	////////////////////
	//#region Overlays
	////////////////////
	onShowBusLocationChange(val) {
		this.ShowBusLocation = val;

		// if(this.ShowBusLocation == true){
		//   this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		// }
		// else{
		//   this.UpdateOverlays();
		// }
		this.onCurrentTimeIntChange(this.LastStartDate.getTime());

		this.UpdatePreferences();
	}

	onShowKnownLocationsChange(val) {
		this.ShowKnownLocations = val;

		// if(this.ShowKnownLocations == true){
		//   this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		// }
		// else{
		//   this.UpdateOverlays();
		// }

		this.onCurrentTimeIntChange(this.LastStartDate.getTime());

		this.UpdatePreferences();
	}

	onShowAccuracyColorChange(val) {
		this.ShowAccuracyColor = val;

		// this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		this.UpdateLabels();

		this.UpdatePreferences();
	}

	onAccuracyFtChange(val) {
		this.AccuracyFt = Number(val);

		if (this.AccuracyFt < 0 || isNaN(this.AccuracyFt) == true) {
			this.AccuracyFt = 0;
		}

		this.UpdateLabels();

		this.UpdatePreferences();
	}

	onShowBusPathChange(val) {
		this.ShowBusPath = val;

		// if(this.ShowBusPath == true){
		//   this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		// }
		// else{
		//   this.UpdateOverlays();
		// }

		this.onCurrentTimeIntChange(this.LastStartDate.getTime());

		this.UpdatePreferences();
	}

	onHideUnselectedChange(val) {
		this.HideUnselected = val;

		if (val == false) {
			this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		} else {
			this.UpdateOverlays();
		}

		// this.onCurrentTimeIntChange(this.LastStartDate.getTime());

		this.UpdatePreferences();
	}

	onCenterOnSelectedChange(val) {
		this.CenterOnSelected = val;

		this.UpdateOverlays();
		this.UpdatePreferences();
	}

	onShowStudentsSwipeOnChange(val) {
		this.ShowStudentsSwipeOn = val;

		if (this.ShowStudentsSwipeOn == false) {
			this.RemoveStudentsOn();
		} else {
			this.UpdateOverlays();
		}

		this.UpdatePreferences();
	}

	onShowStudentSwipeOffChange(val) {
		this.ShowStudentSwipeOff = val;

		if (this.ShowStudentSwipeOff == false) {
			this.RemoveStudentsOff();
		} else {
			this.UpdateOverlays();
		}

		this.UpdatePreferences();
	}

	onShowGeoFencesChange(val) {
		this.ShowGeoFences = val;

		if (this.ShowGeoFences == false) {
			this.ClearAllGeoFences();
		} else {
			this.DrawGeoFences();
		}

		this.UpdatePreferences();
	}

	onHideInactiveGeoFencesChange(val) {
		this.HideInactiveGeoFences = val;

		if (this.ShowGeoFences == true) {
			if (this.HideInactiveGeoFences == true) {
				this.ClearInactiveGeoFences();
			} else {
				this.DrawGeoFences();
			}
		}

		this.UpdatePreferences();
	}

	onBusSchoolOptionIDChange(val) {
		this.BusSchoolOptionID = val;

		this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		this.UpdatePreferences();
	}

	onBusSchoolIDChange(val) {
		this.BusSchoolID = val;

		for (var z = 0; z < this.lstSchool.length; z++) {
			var next = this.lstSchool[z];

			if (next.SchoolID == this.BusSchoolID) {
				this.BusSchool = next;
				break;
			}
		}

		this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		this.UpdatePreferences();
	}

	onBusSchoolChange(val) {
		this.BusSchool = val;
		this.BusSchoolID = this.BusSchool.SchoolID;

		this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		this.UpdatePreferences();
	}

	onBusSeverityOptionChange(val) {
		this.BusSeverityOption = val;

		this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		this.UpdatePreferences();
	}

	onStudentSchoolOptionIDChange(val) {
		this.StudentSchoolOptionID = val;

		this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		this.UpdatePreferences();
	}

	onStudentSchoolIDChange(val) {
		this.StudentSchoolID = val;

		for (var z = 0; z < this.lstSchool.length; z++) {
			var next = this.lstSchool[z];

			if (next.SchoolID == this.StudentSchoolID) {
				this.StudentSchool = next;
				break;
			}
		}

		this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		this.UpdatePreferences();
	}

	onStudentSchoolChange(val) {
		this.StudentSchool = val;
		this.StudentSchoolID = this.StudentSchool.SchoolID;

		this.onCurrentTimeIntChange(this.LastStartDate.getTime());
		this.UpdatePreferences();
	}

	UpdateOverlays() {
		this.ClearAll();

		for (var z = 0; z < this.lstBusHistory.length; z++) {
			var next = this.lstBusHistory[z];

			next.HistoryIndex = 0;
			next.PathIndex = 0;
			next.StudentIndex = 0;
			next.lstPaths = [];
			next.lstCurrentAlerts = [];
			next.HasAlert = false;
			next.Severity = 0;
			next.AlertDesc = "";
			next.StudentCount = next.lstStudentsOnBus.length;
		}

		this.onNext();
	}

	//#endregion
	////////////////////

	////////////////////
	//#region Labels
	////////////////////

	onBusShowBusNbrChange(val) {
		this.BusShowBusNbr = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusShowBusDriverChange(val) {
		this.BusShowBusDriver = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusShowCurrentRouteChange(val) {
		this.BusShowCurrentRoute = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusShowRouteTypeChange(val) {
		this.BusShowRouteType = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusShowAlertDescChange(val) {
		this.BusShowAlertDesc = val;

		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onBusTextColorChange(val) {
		this.BusTextColor = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onKnownLocationShowBusNbrChange(val) {
		this.KnownLocationShowBusNbr = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onKnownLocationShowCDateChange(val) {
		this.KnownLocationShowCDate = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onKnownLocationShowSpeedChange(val) {
		this.KnownLocationShowSpeed = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onKnownLocationShowLatLongChange(val) {
		this.KnownLocationShowLatLong = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onKnownLocationShowDriverChange(val) {
		this.KnownLocationShowDriver = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onLocationTextColorChange(val) {
		this.LocationTextColor = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentNameChange(val) {
		this.ShowStudentName = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentIDChange(val) {
		this.ShowStudentID = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentBusChange(val) {
		this.ShowStudentBus = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowStudentScanTimeChange(val) {
		this.ShowStudentScanTime = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onShowScheduledRiderChange(val) {
		this.ShowScheduledRider = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	onStudentTextColorChange(val) {
		this.StudentTextColor = val;

		// this.UpdateOverlays();
		this.UpdateLabels();
		this.UpdatePreferences();
	}

	//#endregion
	////////////////////

	//#endregion

	//#region Time

	onSpeedOptionChange(val) {
		this.SpeedOption = val;
		this.SecondsPerInterval = this.SpeedOption.SecondsPerInterval;

		if (this.IsPlaying == true) {
			this.onPause();
			this.onPlay();
		}

		this.UpdatePreferences();
	}

	onSecondsPerIntervalChange(val) {
		this.SecondsPerInterval = val;

		var max = 0;
		for (var z = 0; z < this.lstSpeedOption.length; z++) {
			var next = this.lstSpeedOption[z];

			if (this.SecondsPerInterval > next.SecondsPerInterval) {
				max = z;
			}
		}
		this.SpeedOption = this.lstSpeedOption[max];

		if (this.IsPlaying == true) {
			this.onPause();
			this.onPlay();
		}

		this.UpdatePreferences();
	}

	onStartDateChange(val) {
		this.StartDate = val;

		// try{
		//   this.MinTime = this.StartDate.getTime();
		// }
		// catch(e){
		//   e.toString();
		//   this.MinTime = 0;
		// }

		// if(this.CurrentTimeInt < this.MinTime){
		//   this.onCurrentTimeIntChange(this.MinTime);
		// }

		//
		// Check Max Range
		//
		this.CheckMaxRangeStart();

		this.UpdatePreferences();

		// this.onRefresh();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		// try{
		//   this.MaxTime = this.EndDate.getTime();
		// }
		// catch(e){
		//   e.toString();
		//   this.MaxTime = 0;
		// }

		// if(this.CurrentTimeInt > this.MaxTime){
		//   this.onCurrentTimeIntChange(this.MaxTime);
		// }

		//
		// Check Max Range
		//
		this.CheckMaxRangeEnd();

		this.UpdatePreferences();
		// this.onRefresh();
	}

	CheckMaxRangeStart() {
		var StartDateInt = this.StartDate.getTime();
		var EndDateInt = this.EndDate.getTime();

		var StartDateDay = Math.floor(StartDateInt / 1000 / 60 / 60 / 24);
		var EndDateDay = Math.floor(EndDateInt / 1000 / 60 / 60 / 24);

		var DateDiff = EndDateDay - StartDateDay;
		if (Math.abs(DateDiff) > this.MapPrefs.MaxDateRangeDays) {
			var MaxRangeMS = this.MapPrefs.MaxDateRangeDays * 24 * 60 * 60 * 1000;

			var NewEndDate = new Date();
			NewEndDate.setTime(StartDateInt + MaxRangeMS);

			this.onEndDateChange(NewEndDate);
		}
	}

	CheckMaxRangeEnd() {
		var StartDateInt = this.StartDate.getTime();
		var EndDateInt = this.EndDate.getTime();

		var StartDateDay = Math.floor(StartDateInt / 1000 / 60 / 60 / 24);
		var EndDateDay = Math.floor(EndDateInt / 1000 / 60 / 60 / 24);

		var DateDiff = EndDateDay - StartDateDay;
		if (Math.abs(DateDiff) > this.MapPrefs.MaxDateRangeDays) {
			var MaxRangeMS = this.MapPrefs.MaxDateRangeDays * 24 * 60 * 60 * 1000;

			var NewStartDate = new Date();
			NewStartDate.setTime(EndDateInt - MaxRangeMS);

			this.onStartDateChange(NewStartDate);
		}
	}

	onCurrentDTChange(val) {
		var OldDT: Date = new Date(this.CurrentTimeInt);
		this.CurrentDT = new Date(val);

		if (this.LastStartDate != undefined && this.CurrentDT < this.LastStartDate) {
			this.CurrentDT = new Date(this.LastStartDate);
		}

		if (this.LastEndDate != undefined && this.CurrentDT > this.LastEndDate) {
			this.CurrentDT = new Date(this.LastEndDate);
		}

		this.CurrentTimeInt = this.CurrentDT.getTime();

		// this.UpdateOverlays();
		this.onJumpDate(OldDT, val);
		this.UpdatePreferences();
	}

	onCurrentTimeIntChange(val) {
		var OldTimeInt = this.CurrentDT.getTime();
		this.CurrentTimeInt = val;

		this.CurrentDT = new Date(this.CurrentTimeInt);

		// this.UpdateOverlays();
		this.onJumpInt(OldTimeInt, val);
		this.UpdatePreferences();
	}
	//#endregion

	//#region Selector Bar
	onSelectBusesOnMap(val) {
		this.BusesFromSelector = val.Buses;
		this.StudentsFromSelector = val.Students;

		this.UpdateOverlays();
		this.UpdatePreferences();
	}
	//#endregion

	//#endregion
	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	//#region Misc
	//////////////////////////////////////////////////////////////////////

	//#region Preferences

	UpdatePreferences() {
		let BT_HistoryMapOptions: any = {
			StartDate: this.StartDate,
			EndDate: this.EndDate,
			CurrentDT: this.CurrentDT,
			CurrentTimeInt: this.CurrentTimeInt,
			MinTime: this.MinTime,
			MaxTime: this.MaxTime,
			//Overlays
			ShowKnownLocations: this.ShowKnownLocations,
			ShowAccuracyColor: this.ShowAccuracyColor,
			AccuracyFt: this.AccuracyFt,
			ShowBusPath: this.ShowBusPath,
			ShowBusLocation: this.ShowBusLocation,
			HideUnselected: this.HideUnselected,
			ShowStudentsSwipeOn: this.ShowStudentsSwipeOn,
			ShowStudentSwipeOff: this.ShowStudentSwipeOff,
			ShowGeoFences: this.ShowGeoFences,
			HideInactiveGeoFences: this.HideInactiveGeoFences,
			//Labels
			//KnownLocations
			KnownLocationShowBusNbr: this.KnownLocationShowBusNbr,
			KnownLocationShowCDate: this.KnownLocationShowCDate,
			KnownLocationShowSpeed: this.KnownLocationShowSpeed,
			KnownLocationShowLatLong: this.KnownLocationShowLatLong,
			KnownLocationShowDriver: this.KnownLocationShowDriver,
			LocationTextColor: this.LocationTextColor,
			//Bus
			BusShowBusNbr: this.BusShowBusNbr,
			BusShowBusDriver: this.BusShowBusDriver,
			BusShowCurrentRoute: this.BusShowCurrentRoute,
			BusShowRouteType: this.BusShowRouteType,
			BusShowAlertDesc: this.BusShowAlertDesc,
			CenterOnSelected: this.CenterOnSelected,
			BusTextColor: this.BusTextColor,
			//Students
			ShowStudentName: this.ShowStudentName,
			ShowStudentID: this.ShowStudentID,
			ShowStudentBus: this.ShowStudentBus,
			ShowStudentScanTime: this.ShowStudentScanTime,
			ShowScheduledRider: this.ShowScheduledRider,
			StudentTextColor: this.StudentTextColor,
			SpeedOptionID: this.SpeedOption.ID,
			SecondsPerInterval: this.SecondsPerInterval,
			BusSchoolOptionID: this.BusSchoolOptionID,
			StudentSchoolOptionID: this.StudentSchoolOptionID,
			BusSchoolID: this.BusSchoolID,
			StudentSchoolID: this.StudentSchoolID,
		};

		this.localService.setItem("BT_History_MapOptions", BT_HistoryMapOptions);
	}

	//#endregion

	//#region Time
	AdvanceSeconds(sec) {
		var newDT: Date = this.CurrentDT;

		newDT.setTime(newDT.getTime() + 1000 * sec);

		if (newDT > this.LastEndDate) {
			newDT = this.LastEndDate;
		}

		this.CurrentDT = new Date(newDT);
		this.CurrentTimeInt = this.CurrentDT.getTime();

		this.onNext();
	}

	ReverseSeconds(sec) {
		// var newDT: Date = this.CurrentDT;

		// newDT.setTime(newDT.getTime() + (-1 * 1000 * sec));

		// if(newDT < this.StartDate){
		//   newDT = this.StartDate;
		// }

		var newDT: Date = this.CurrentDT;

		newDT.setTime(newDT.getTime() + -1 * 1000 * sec);

		if (newDT > this.LastEndDate) {
			newDT = this.LastEndDate;
		}

		this.CurrentDT = new Date(newDT);
		this.CurrentTimeInt = this.CurrentDT.getTime();

		this.JumpBackwards();
		// this.onCurrentTimeIntChange(newDT.getTime());
	}

	//#endregion

	//#region Loading

	IsLoading() {
		return this.PrefLoading == true || this.HistoryLoading == true;
	}

	DatesChanged() {
		var NewStart = new Date(this.StartDate).getTime();
		var OldStart = new Date(this.LastStartDate).getTime();
		var NewEnd = new Date(this.EndDate).getTime();
		var OldEnd = new Date(this.LastEndDate).getTime();

		return NewStart != OldStart || NewEnd != OldEnd || this.lstBusHistory.length == 0;
	}

	//#endregion

	//#region Spiderfy Students

	SpiderfyUpdateOverlapList(event) {
		//////////////////////////////////////////////////////////////////
		//#region Get list of overlapping features (on Data Layer)
		//////////////////////////////////////////////////////////////////

		var scale = 1 << this.mapRef.map.getZoom();

		var WorldCoordinate = this.project(
			new google.maps.LatLng({
				lat: event.feature.getProperty("Lat"),
				lng: event.feature.getProperty("Long"),
			})
		);
		var PixelCoordinate = new google.maps.Point(Math.floor(WorldCoordinate.x * scale), Math.floor(WorldCoordinate.y * scale));

		this.lstOverlaps = [];

		this.mapRef.map.data.forEach((element) => {
			if (element.getProperty("Type") == "Student") {
				var NextWorldCoordinate = this.project(
					new google.maps.LatLng({
						lat: element.getProperty("Lat"),
						lng: element.getProperty("Long"),
					})
				);
				var NextPixelCoordinate = new google.maps.Point(Math.floor(NextWorldCoordinate.x * scale), Math.floor(NextWorldCoordinate.y * scale));

				var DistanceSq = Math.pow(NextPixelCoordinate.x - PixelCoordinate.x, 2) + Math.pow(NextPixelCoordinate.y - PixelCoordinate.y, 2);

				if (
					DistanceSq < Math.pow(this.Tolerance, 2) &&
					element.getProperty("BusStudentRideTxnID") != event.feature.getProperty("BusStudentRideTxnID")
				) {
					var nextEntry = element;
					// {
					//   Feature: element,
					//   DistanceSq: DistanceSq
					// };

					this.lstOverlaps = [...this.lstOverlaps, nextEntry];
				}
			}
		});

		//
		// Sort by distance ascending
		//
		// this.lstOverlaps.sort((a, b) => a.DistanceSq - b.DistanceSq);
		// for(var z = 0; z < this.lstOverlaps.length; z++){
		//   var next = this.lstOverlaps[z];
		//   this.lstOverlaps[z] = next.Feature;
		// }

		//#endregion
		//////////////////////////////////////////////////////////////////

		return;
	}

	StudentSpiderfy(event) {
		this.SpiderfyBusStudentRideTxnID = event.feature.getProperty("BusStudentRideTxnID");

		//////////////////////////////////////////////////////////////////
		//#region Move overlapping points out of the way
		//////////////////////////////////////////////////////////////////

		for (var z = 0; z < this.lstOverlaps.length; z++) {
			var next = this.lstOverlaps[z];

			next.setGeometry(this.SpiderGeometry(event.feature, next, z));
		}

		//#endregion
		//////////////////////////////////////////////////////////////////

		this.overlays = [...this.overlays, ...this.lstSpiderOverlays];
	}

	//
	// Return a google.maps.Data.Point for spiderfying
	//
	SpiderGeometry(Origin, feature, Index) {
		//
		// NEW, Circle from origin
		//

		var Layer: any = Math.floor(Index / this.SpiderMaxLegs);

		var CurrentZoom: any = this.mapRef.map.getZoom();

		var M_PX = 591657550.5 / Math.pow(2, CurrentZoom);
		var Length = (Layer + 1) * this.ZoomCoefficient * M_PX;

		var NewLat: any = Origin.getProperty("Lat") + Length * Math.cos((Index * 2 * Math.PI) / this.SpiderMaxLegs);
		var NewLong: any = Origin.getProperty("Long") + Length * Math.sin((Index * 2 * Math.PI) / this.SpiderMaxLegs);

		//
		// NEW
		//
		// Make web connecting points in spiral
		//
		if (this.lstSpiderOverlays.length > 0) {
			var lastPath = this.lstSpiderOverlays[this.lstSpiderOverlays.length - 1].getPath();
			var lastPoint = lastPath.getAt(1);

			this.lstSpiderOverlays.push(
				new google.maps.Polyline({
					path: [
						{ lat: lastPoint.lat(), lng: lastPoint.lng() },
						{ lat: NewLat, lng: NewLong },
					],
					strokeColor: "#FF0000", //Index % 2 == 0 ? "#FF0000" : "#0000FF",
					strokeOpacity: 1.0,
					strokeWeight: 2,
				})
			);
		} else {
			this.lstSpiderOverlays.push(
				new google.maps.Polyline({
					path: [
						{
							lat: Origin.getProperty("Lat"),
							lng: Origin.getProperty("Long"),
						},
						{ lat: NewLat, lng: NewLong },
					],
					strokeColor: Index % 2 == 0 ? "#FF0000" : "#0000FF",
					strokeOpacity: 1.0,
					strokeWeight: 2,
				})
			);
		}

		return new google.maps.Data.Point(
			new google.maps.LatLng({
				lat: NewLat,
				lng: NewLong,
			})
		);
	}

	StudentUnSpiderfy() {
		this.SpiderfyBusStudentRideTxnID = -1;

		for (var z = 0; z < this.lstOverlaps.length; z++) {
			var next = this.lstOverlaps[z];

			next.setGeometry(
				new google.maps.Data.Point(
					new google.maps.LatLng({
						lat: next.getProperty("Lat"),
						lng: next.getProperty("Long"),
					})
				)
			);
		}

		this.lstOverlaps = [];

		this.overlays = this.overlays.filter((overlay) => this.lstSpiderOverlays.indexOf(overlay) == -1);
		this.lstSpiderOverlays = []; //Delete lines that show the position changed (NOTE: DOESN'T AFFECT ACTUAL OVERLAYS, they're data layer objects)
	}

	// The mapping between latitude, longitude and pixels is defined by the web
	// mercator projection.
	project(latLng: google.maps.LatLng) {
		let siny = Math.sin((latLng.lat() * Math.PI) / 180);

		// Truncating to 0.9999 effectively limits latitude to 89.189. This is
		// about a third of a tile past the edge of the world tile.
		siny = Math.min(Math.max(siny, -0.9999), 0.9999);

		return new google.maps.Point(256 * (0.5 + latLng.lng() / 360), 256 * (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI)));
	}

	SelectStudent(event) {
		/////////////////////////////////////////////////////////////////////////////////////////////////////
		// Select or deselect Bus
		/////////////////////////////////////////////////////////////////////////////////////////////////////

		var tempSelected = event.feature.getProperty("Selected");

		var NewSelected = true;
		if (tempSelected == true) {
			NewSelected = false;
		}

		event.feature.setProperty("Selected", NewSelected);

		// var Student_PersonID = event.feature.getProperty("Student_PersonID");

		// if(NewSelected == true){
		//   for(var z = 0; z < this.lstStudentPositions.length; z++){
		//     var next = this.lstStudentPositions[z];

		//     if(next.Student_PersonID == Student_PersonID){
		//       this.lstSelectedStudents = [...this.lstSelectedStudents, next];
		//       break;
		//     }
		//   }

		//   // this.mapRef.map.setCenter( { lat: event.feature.getProperty("Lat"), lng: event.feature.getProperty("Long") } );

		// }
		// else{
		//   this.lstSelectedStudents = this.lstSelectedStudents.filter(student =>  student.Student_PersonID != Student_PersonID);
		// }

		/////////////////////////////////////////////////////////////////////////////////////////////////////
	}

	//#endregion

	//#region Selected and Center On

	BusSelected(BusID: number): boolean {
		var ManuallySelected = false;
		for (var i = 0; i < this.lstSelectedBuses.length; i++) {
			var nextSelectedBus = this.lstSelectedBuses[i];

			if (nextSelectedBus.BusID == BusID) {
				ManuallySelected = true;
				break;
			}
		}

		var FromSelector = false;
		// if(ManuallySelected == false && this.ShowSideBar == true){
		if (ManuallySelected == false) {
			for (var i = 0; i < this.BusesFromSelector.length; i++) {
				var nextSelectedBus = this.BusesFromSelector[i];

				if (nextSelectedBus == BusID) {
					FromSelector = true;
					break;
				}
			}
		}

		return FromSelector == true || ManuallySelected == true;
	}

	CenterOnLastSelected() {
		if (this.CenterOnSelected == true && (this.lstSelectedBuses.length > 0 || this.BusesFromSelector.length > 0)) {
			var CenterBusID: any;

			// Try manually selected first
			if (this.lstSelectedBuses.length > 0) {
				CenterBusID = this.lstSelectedBuses[this.lstSelectedBuses.length - 1].BusID;
			}
			// Else go with selections from selector
			else {
				CenterBusID = this.BusesFromSelector[this.BusesFromSelector.length - 1];
			}

			this.mapRef.map.data.forEach((element) => {
				try {
					if (element.getProperty("Type") == "Bus" && element.getProperty("BusID") == CenterBusID) {
						var Geom = element.getGeometry();
						var LatLng: google.maps.LatLng;

						Geom.forEachLatLng((ll) => {
							LatLng = ll;
						});

						this.mapRef.map.setCenter(LatLng);
					}
				} catch (e) {
					e.toString();
				}
			});
		}
	}

	//#endregion

	//#endregion
	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	//#region Map Processing
	//////////////////////////////////////////////////////////////////////

	///////////////////////////
	//#region Play
	///////////////////////////
	onNext() {
		// this.UpdateMapStylesAndListeners();

		this.Processing = true;

		//
		// Go through each bus
		//
		for (var z = 0; z < this.lstBusHistory.length; z++) {
			var next = this.lstBusHistory[z];

			//
			// Check if bus is valid based on the BusSchoolOptionID (All, My School Only, Specific School)
			//
			var BusValid: boolean = false;
			if (this.BusSchoolOptionID == 0) {
				BusValid = true;
			} else if (this.BusSchoolOptionID == 1 && next.IsMySchool == true) {
				BusValid = true;
			} else if (this.BusSchoolOptionID == 2) {
				for (var z = 0; z < next.lstSchoolIDs.length; z++) {
					var sID = next.lstSchoolIDs[z];

					if (sID == this.BusSchoolID) {
						BusValid = true;
						break;
					}
				}
			}

			var BusSeverityValid: any = true;
			if (this.BusSeverityOption != 0) {
				//
				// Has Alert?
				//
				if (this.BusSeverityOption == -1) {
					// Bus Has no alerts, so skip
					if (next.lstAlerts.length == 0) {
						BusSeverityValid = false;
					}
				}
				//
				// No alerts
				//
				else if (this.BusSeverityOption == -2) {
					// Bus Has an alert, so skip
					if (next.lstAlerts.length > 0) {
						BusSeverityValid = false;
					}
				}
				//
				// Low
				//
				else if (this.BusSeverityOption == 3) {
					var sevFound: any = false;

					for (var x = 0; x < next.lstAlerts.length; x++) {
						var nextAlert = next.lstAlerts[x];

						if (nextAlert.Severity == 3) {
							sevFound = true;
							break;
						}
					}

					if (!sevFound) {
						BusSeverityValid = false;
					}
				}
				//
				// Medium
				//
				else if (this.BusSeverityOption == 2) {
					var sevFound: any = false;

					for (var x = 0; x < next.lstAlerts.length; x++) {
						var nextAlert = next.lstAlerts[x];

						if (nextAlert.Severity == 2) {
							sevFound = true;
							break;
						}
					}

					if (!sevFound) {
						BusSeverityValid = false;
					}
				}
				//
				// High
				//
				else if (this.BusSeverityOption == 1) {
					var sevFound: any = false;

					for (var x = 0; x < next.lstAlerts.length; x++) {
						var nextAlert = next.lstAlerts[x];

						if (nextAlert.Severity == 1) {
							sevFound = true;
							break;
						}
					}

					if (!sevFound) {
						BusSeverityValid = false;
					}
				}

				//
				// Speeding
				//
				else if (this.BusSeverityOption == -3) {
					var SpeedLimit: any = 70;

					var SpeedingFound: any = false;
					for (var x = 0; x < next.lstHistory.length; x++) {
						var nextPosition = next.lstHistory[x];

						if (Number(nextPosition.SpeedMph) >= SpeedLimit) {
							SpeedingFound = true;
							break;
						}
					}

					if (!SpeedingFound) {
						BusSeverityValid = false;
					}
				}
			}

			//
			// If some buses are being hidden:
			//
			if (this.HideUnselected == true) {
				//Check if bus should be draw/looked at

				var BusSelected: boolean = this.BusSelected(next.BusID);

				//
				// Draw the bus if it's selected
				//
				if (BusSelected == true && BusValid == true && BusSeverityValid == true) {
					while (this.BusNextCycle(z, next) == true) {}
				}
			}
			//
			// Normal mode, draw all buses
			//
			else {
				if (BusValid == true && BusSeverityValid == true) {
					while (this.BusNextCycle(z, next) == true) {}
				}
			}
		}

		this.CenterOnLastSelected();

		this.Processing = false;
	}

	BusNextCycle(Index: number, BusInfo: any) {
		var Ind: any = BusInfo.HistoryIndex;
		var Continue: boolean = false;

		//
		// Should the bus be inited on map?
		//
		if (Ind == 0) {
			if (BusInfo.lstHistory.length > 0) {
				var nextDate: Date = new Date(BusInfo.lstHistory[0].c_date);

				if (nextDate <= this.CurrentDT) {
					this.InitBus(BusInfo, BusInfo.lstHistory[0]);
					this.DrawMarker(BusInfo, BusInfo.lstHistory[0]);

					// this.DrawPath(BusInfo.BusID, Ind, BusInfo.PathIndex, Index, Number(BusInfo.lstHistory[0].Lat), Number(BusInfo.lstHistory[0].Long), Number(BusInfo.lstHistory[0].Lat), Number(BusInfo.lstHistory[0].Long));

					BusInfo.HistoryIndex++;
					Continue = true;
				}
			}
		}
		//
		// Update Bus Position
		//
		else if (Ind < BusInfo.lstHistory.length) {
			var nextDate: Date = new Date(BusInfo.lstHistory[Ind].c_date);

			//
			// Hit next point?
			//
			if (nextDate <= this.CurrentDT) {
				this.UpdateBusPositionNextPoint(BusInfo, BusInfo.lstHistory[Ind]);
				this.DrawMarker(BusInfo, BusInfo.lstHistory[Ind]);

				var Prev = BusInfo.lstHistory[Ind - 1];
				var Next = BusInfo.lstHistory[Ind];

				this.DrawPath(
					BusInfo.BusID,
					Prev.BusLocationLogID,
					Next.BusLocationLogID,
					Index,
					Number(Prev.Lat),
					Number(Prev.Long),
					Number(Next.Lat),
					Number(Next.Long)
				);

				BusInfo.HistoryIndex++;
				BusInfo.PathIndex++;
				Continue = true;
			}

			//
			// Between points?
			//
			else {
				this.UpdateBusPositionBetweenPoints(Index, BusInfo, BusInfo.lstHistory[Ind - 1], BusInfo.lstHistory[Ind], this.CurrentDT);
			}
		}
		//
		// Else Bus is finished with its data
		//

		//
		// Process Students
		//
		if (BusInfo.lstStudentScans.length > 0 && BusInfo.StudentIndex < BusInfo.lstStudentScans.length) {
			if (BusInfo.StudentIndex < 0) {
				BusInfo.StudentIndex = 0;
			}

			var nextStu: any = BusInfo.lstStudentScans[BusInfo.StudentIndex];
			var nextDate: Date = new Date(nextStu.c_date);

			while (BusInfo.StudentIndex < BusInfo.lstStudentScans.length && nextDate <= this.CurrentDT) {
				this.DrawStudentMarker(nextStu);

				BusInfo.StudentIndex += 1;

				if (BusInfo.StudentIndex < BusInfo.lstStudentScans.length) {
					nextStu = BusInfo.lstStudentScans[BusInfo.StudentIndex];
					nextDate = new Date(nextStu.c_date);
				}
			}
		}

		this.BusProcessAlerts(BusInfo);

		return Continue;
	}

	onPrevious() {
		this.UpdateMapStylesAndListeners();

		this.Processing = true;

		//
		// Go through each bus
		//
		for (var z = 0; z < this.lstBusHistory.length; z++) {
			var next = this.lstBusHistory[z];

			//
			// If some buses are being hidden:
			//
			if (this.HideUnselected == true) {
				//Check if bus should be draw/looked at
			}
			//
			// Normal mode, update all buses
			//
			else {
				while (this.BusPreviousCycle(z, next) == true) {}
			}
		}

		this.CenterOnLastSelected();

		this.Processing = false;
	}

	BusPreviousCycle(Index: number, BusInfo: any) {
		var Ind: any = BusInfo.HistoryIndex;
		var Continue: boolean = false;

		if (Ind == BusInfo.lstHistory.length) {
			Ind--;
		}

		if (Ind >= 0) {
			var next = BusInfo.lstHistory[Ind];
			var nextDate = new Date(next.c_date);

			if (nextDate > new Date(this.CurrentDT)) {
				//
				// Remove Buses, Positions, Paths, Students
				//
				if (Ind > 0) {
					//
					// Bus is between points?
					//
					var prev = BusInfo.lstHistory[Ind - 1];
					var prevDate = new Date(prev.c_date);

					if (prevDate <= this.CurrentDT) {
						this.RemoveMarker(next.BusLocationLogID);

						this.UpdateBusPositionBetweenPoints(Index, BusInfo, prev, next, new Date(this.CurrentDT));
					}
					//Both will get deleted
					else {
						this.DeletePathBetween(prev.BusLocationLogID, next.BusLocationLogID);

						this.UpdateBusPositionNextPoint(BusInfo, prev);
						this.RemoveMarker(next.BusLocationLogID);
					}

					BusInfo.HistoryIndex--;
					Continue = true;
				} else {
					this.DeleteAllPathsForBus(BusInfo.BusID);

					this.RemoveBus(BusInfo.BusID);
					this.RemoveMarker(next.BusLocationLogID);
				}
			}
		}

		//
		// Process Students
		//
		if (BusInfo.lstStudentScans.length > 0 && BusInfo.StudentIndex >= 0) {
			if (BusInfo.StudentIndex >= BusInfo.lstStudentScans.length) {
				BusInfo.StudentIndex = BusInfo.lstStudentScans.length - 1;
			}

			var nextStu: any = BusInfo.lstStudentScans[BusInfo.StudentIndex];
			var nextStuDate: Date = new Date(nextStu.c_date);

			while (BusInfo.StudentIndex >= 0 && nextStuDate > this.CurrentDT) {
				this.RemoveStudent(nextStu.BusStudentRideTxnID);

				BusInfo.StudentIndex -= 1;

				if (BusInfo.StudentIndex >= 0) {
					nextStu = BusInfo.lstStudentScans[BusInfo.StudentIndex];
					nextStuDate = new Date(nextStu.c_date);
				}
			}
		}

		this.BusProcessAlerts(BusInfo);

		return Continue;
	}

	BusProcessAlerts(BusInfo) {
		if (BusInfo.lstAlerts.length > 0) {
			BusInfo.lstCurrentAlerts = [];

			for (var z = 0; z < BusInfo.lstAlerts.length; z++) {
				var nextAlert = BusInfo.lstAlerts[z];
				var nextStartDate: Date = new Date(nextAlert.StartDT);
				var nextEndDate: Date = new Date(nextAlert.EndDT);

				//End Loop
				if (nextStartDate > this.CurrentDT) {
					break;
				}

				if (nextStartDate <= this.CurrentDT && nextEndDate >= this.CurrentDT) {
					BusInfo.lstCurrentAlerts = [...BusInfo.lstCurrentAlerts, nextAlert];
				}
			}

			if (BusInfo.lstCurrentAlerts.length > 0) {
				BusInfo.lstCurrentAlerts = BusInfo.lstCurrentAlerts.sort((a, b) => Number(a.Severity) - Number(b.Severity));

				// console.log("Bus");
				// console.log(BusInfo);
				// console.log("Current Alerts");
				// console.log(BusInfo.lstCurrentAlerts);

				var AlertInfo: any = BusInfo.lstCurrentAlerts[0];
				var AlertDesc: string = AlertInfo.AlertTypeDesc;

				if (AlertInfo.Comments != "") {
					AlertDesc = AlertInfo.Comments;
				}

				//
				// Update if it doesn't have the correct alert
				//
				if (BusInfo.HasAlert == false || BusInfo.Severity != AlertInfo.Severity || BusInfo.AlertDesc != AlertDesc) {
					BusInfo.HasAlert = true;
					BusInfo.Severity = AlertInfo.Severity;
					BusInfo.AlertDesc = AlertDesc;
					this.UpdateAlert(BusInfo.BusID, AlertInfo.Severity, AlertDesc);

					this.PlayAlertSound(BusInfo.Severity, AlertInfo.AlertTypeDesc);
				}
			} else {
				if (BusInfo.HasAlert == true) {
					BusInfo.HasAlert = false;
					BusInfo.Severity = 0;
					BusInfo.AlertDesc = "";

					this.ClearAlert(BusInfo.BusID);
				}
			}
		}
	}

	UpdateAlert(BusID, Severity, AlertDesc) {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Bus") {
					if (element.getProperty("BusID") == BusID) {
						//
						// Update label for bus that just got an alert
						//
						let NextLabel: any = "";

						if (this.BusShowBusNbr == true) {
							NextLabel += element.getProperty("BusNbr") + " ";
						}
						if (this.BusShowAlertDesc == true) {
							NextLabel += "(" + AlertDesc + ") ";
						}
						if (this.BusShowBusDriver == true) {
							NextLabel += "(" + element.getProperty("DriverName") + ") ";
						}
						if (this.BusShowCurrentRoute == true) {
							NextLabel += "(" + element.getProperty("BusRouteDesc") + ") ";
						}
						if (this.BusShowRouteType == true) {
							NextLabel += "(" + element.getProperty("BusRouteTypeDesc") + ") ";
						}

						element.setProperty("BusLabel", NextLabel);
						element.setProperty("Severity", Severity);
						element.setProperty("HasAlert", true);
						element.setProperty("AlertDesc", AlertDesc);

						return;
					}
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	ClearAlert(BusID) {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Bus") {
					if (element.getProperty("BusID") == BusID) {
						element.setProperty("Severity", 0);
						element.setProperty("HasAlert", false);
						element.setProperty("AlertDesc", "");

						if (this.BusShowAlertDesc == true) {
							//
							// Update label for bus that just lost an alert
							//
							let NextLabel: any = "";

							if (this.BusShowBusNbr == true) {
								NextLabel += element.getProperty("BusNbr") + " ";
							}
							// if(this.BusShowAlertDesc == true && element.getProperty("HasAlert") == true){
							//   NextLabel += "(" + element.getProperty("AlertDesc") + ") ";
							// }
							if (this.BusShowBusDriver == true) {
								NextLabel += "(" + element.getProperty("DriverName") + ") ";
							}
							if (this.BusShowCurrentRoute == true) {
								NextLabel += "(" + element.getProperty("BusRouteDesc") + ") ";
							}
							if (this.BusShowRouteType == true) {
								NextLabel += "(" + element.getProperty("BusRouteTypeDesc") + ") ";
							}

							element.setProperty("BusLabel", NextLabel);
						}

						return;
					}
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region  Jump to Date
	///////////////////////////

	onJumpDate(Prev: Date, Next: Date) {
		//
		// Check if going forwards or backwards
		//
		if (Next >= Prev) {
			this.JumpForwards();
		} else {
			this.JumpBackwards();
		}
	}

	onJumpInt(Prev: number, Next: number) {
		//
		// Check if going forwards or backwards
		//
		if (Next >= Prev) {
			this.JumpForwards();
		} else {
			this.JumpBackwards();
		}
	}

	JumpForwards() {
		this.Forwards = true;

		//
		// Jump forwards and draw all of the changes
		// that happened between the two times
		//

		//Just run OnNext and it will
		//update to the most recent positions
		this.onNext();
	}

	JumpBackwards() {
		this.Forwards = false;

		//
		// Jump backwards and remove all of the
		//    -Buses
		//    -Locations
		//    -Paths
		//    -Students
		// that didn't happen yet
		// Update buses that exist to the correct position
		//

		//
		// Faster Method (Paths can get messed up, half deleted?)
		// Incrementally deletes
		// this.onPrevious();

		//
		// Slower but more accurate (Paths refresh properly)
		// Clear all and redraw from the start
		//
		this.UpdateOverlays();

		this.Forwards = true;
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region Draw Bus
	///////////////////////////

	InitBus(BusInfo, PositionInfo) {
		if (this.ShowBusLocation == false) {
			return;
		}

		this.DrawBusMarker(
			BusInfo,
			PositionInfo.DriverName,
			PositionInfo.SpeedMph,
			false,
			PositionInfo.Lat,
			PositionInfo.Long,
			PositionInfo.HorizontalAccuracy,
			PositionInfo.BusRouteTypeDesc,
			PositionInfo.BusRouteDesc
		);
	}

	RemoveBus(BusID) {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Bus") {
					if (element.getProperty("BusID") == BusID) {
						this.mapRef.map.data.remove(element);
						return;
					}
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	UpdateBusPositionNextPoint(BusInfo, PositionInfo) {
		this.UpdateBusLocation(
			BusInfo.BusID,
			PositionInfo.DriverName,
			PositionInfo.SpeedMph,
			false,
			PositionInfo.Lat,
			PositionInfo.Long,
			PositionInfo.HorizontalAccuracy,
			PositionInfo.BusRouteTypeDesc,
			PositionInfo.BusRouteDesc
		);
	}

	UpdateBusPositionBetweenPoints(Index: number, BusInfo: any, PreviousPositionInfo: any, NextPositionInfo: any, TimeDT: Date) {
		var nextLat: number = 0;
		var nextLong: number = 0;
		var CalcData: number[] = this.LinearInterpolation(
			new Date(PreviousPositionInfo.c_date),
			PreviousPositionInfo.Lat,
			PreviousPositionInfo.Long,
			new Date(NextPositionInfo.c_date),
			NextPositionInfo.Lat,
			NextPositionInfo.Long,
			TimeDT
		);

		nextLat = CalcData[0];
		nextLong = CalcData[1];

		this.UpdateBusLocation(
			BusInfo.BusID,
			PreviousPositionInfo.DriverName,
			PreviousPositionInfo.SpeedMph,
			true,
			nextLat,
			nextLong,
			PreviousPositionInfo.HorizontalAccuracy,
			PreviousPositionInfo.BusRouteTypeDesc,
			PreviousPositionInfo.BusRouteDesc
		);
		this.UpdatePath(
			BusInfo.BusID,
			PreviousPositionInfo.BusLocationLogID,
			NextPositionInfo.BusLocationLogID,
			Index,
			Number(PreviousPositionInfo.Lat),
			Number(PreviousPositionInfo.Long),
			nextLat,
			nextLong
		);
	}

	LinearInterpolation(d1: Date, Lat1: number, Long1: number, d2: Date, Lat2: number, Long2: number, Current: Date) {
		var nextLat: number = 0;
		var nextLong: number = 0;

		var timePercent: number = (Current.getTime() - d1.getTime()) / (d2.getTime() - d1.getTime());

		nextLat = Lat1 + (Lat2 - Lat1) * timePercent;
		nextLong = Long1 + (Long2 - Long1) * timePercent;

		return [nextLat, nextLong];
	}

	DrawBusMarker(BusInfo, DriverName, SpeedMph, Approx, Lat, Long, HorizontalAccuracy, RouteType, RouteDesc) {
		if (this.ShowBusLocation == false) {
			return;
		}

		var Exists: boolean = false;

		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Bus") {
					if (element.getProperty("BusID") == BusInfo.BusID) {
						Exists = true;
						return;
					}
				}
			} catch (e) {
				e.toString();
			}
		});

		if (!Exists) {
			let NextLabel: any = "";

			if (this.BusShowBusNbr == true) {
				NextLabel += BusInfo.BusNbr + " ";
			}
			if (this.BusShowAlertDesc == true && BusInfo.HasAlert == true) {
				NextLabel += "(" + BusInfo.AlertDesc + ") ";
			}
			if (this.BusShowBusDriver == true) {
				NextLabel += "(" + BusInfo.DriverName + ") ";
			}
			if (this.BusShowCurrentRoute == true) {
				NextLabel += "(" + RouteDesc + ") ";
			}
			if (this.BusShowRouteType == true) {
				NextLabel += "(" + RouteType + ") ";
			}

			let BusLocation: google.maps.LatLng = new google.maps.LatLng(Lat, Long);
			let BusPoint: google.maps.Data.Point = new google.maps.Data.Point(BusLocation);
			let BusFeatureOptions: google.maps.Data.FeatureOptions = {
				geometry: BusPoint,
				properties: {
					Type: "Bus",
					BusTextColor: this.BusTextColor,
					BusLabel: NextLabel,
					BusID: BusInfo.BusID,
					BusNbr: BusInfo.BusNbr,
					BusDesc: BusInfo.BusDesc,
					DriverName: DriverName,
					SpeedMph: SpeedMph,
					BusRouteDesc: RouteDesc,
					BusRouteTypeDesc: RouteType,
					Lat: Lat,
					Long: Long,
					HorizontalAccuracy: HorizontalAccuracy,
					Approx: Approx,
					StudentCount: BusInfo.StudentCount,
					lstStudentsOnBus: BusInfo.lstStudentsOnBus,
					HasAlert: false,
					AlertDesc: "",
					Severity: 0,
					Selected: this.BusSelected(BusInfo.BusID),
					IsMySchool: BusInfo.IsMySchool,
				},
			};

			let BusFeature: google.maps.Data.Feature = new google.maps.Data.Feature(BusFeatureOptions);
			this.mapRef.map.data.add(BusFeature);
		}
	}

	UpdateBusLocation(BusID, DriverName, SpeedMph, Approx, Lat, Long, HorizontalAccuracy, RouteType, RouteDesc) {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Bus" && element.getProperty("BusID") == BusID) {
					let newLocation: google.maps.LatLng = new google.maps.LatLng(Lat, Long);
					let newGeom: google.maps.Data.Point = new google.maps.Data.Point(newLocation);

					element.setGeometry(newGeom);

					//For popup?
					element.setProperty("DriverName", DriverName);
					element.setProperty("SpeedMph", SpeedMph);
					element.setProperty("Lat", Lat);
					element.setProperty("Long", Long);
					element.setProperty("HorizontalAccuracy", HorizontalAccuracy);
					element.setProperty("Approx", Approx);
					element.setProperty("BusRouteTypeDesc", RouteType);
					element.setProperty("BusRouteDesc", RouteDesc);
					element.setProperty("Selected", this.BusSelected(element.getProperty("BusID")));

					let NextLabel: any = "";

					if (this.BusShowBusNbr == true) {
						NextLabel += element.getProperty("BusNbr") + " ";
					}
					if (this.BusShowAlertDesc == true && element.getProperty("HasAlert") == true) {
						NextLabel += "(" + element.getProperty("AlertDesc") + ") ";
					}
					if (this.BusShowBusDriver == true) {
						NextLabel += "(" + element.getProperty("DriverName") + ") ";
					}
					if (this.BusShowCurrentRoute == true) {
						NextLabel += "(" + element.getProperty("BusRouteDesc") + ") ";
					}
					if (this.BusShowRouteType == true) {
						NextLabel += "(" + element.getProperty("BusRouteTypeDesc") + ") ";
					}

					element.setProperty("BusTextColor", this.BusTextColor);
					element.setProperty("BusLabel", NextLabel);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region Draw Known Location
	///////////////////////////

	DrawMarker(BusInfo, PositionInfo) {
		if (this.ShowKnownLocations == false) {
			return;
		}

		if (this.HideUnselected == true && this.BusSelected(BusInfo.BusID) == false) {
			return;
		}

		let NextLabel: any = "";

		if (this.KnownLocationShowBusNbr == true) {
			NextLabel += BusInfo.BusNbr + " ";
		}
		if (this.KnownLocationShowCDate == true) {
			NextLabel += "(" + PositionInfo.c_dateDesc + ") ";
		}
		if (this.KnownLocationShowSpeed == true) {
			NextLabel += "(" + PositionInfo.SpeedMph + " mph) ";
		}
		if (this.KnownLocationShowLatLong == true) {
			NextLabel += "(" + PositionInfo.Lat + ", " + PositionInfo.Long + ") ";
		}
		if (this.KnownLocationShowDriver == true) {
			NextLabel += "(" + PositionInfo.DriverName + ") ";
		}

		let KnownLocationLocation: google.maps.LatLng = new google.maps.LatLng(PositionInfo.Lat, PositionInfo.Long);
		let KnownLocationPoint: google.maps.Data.Point = new google.maps.Data.Point(KnownLocationLocation);
		let KnownLocationFeatureOptions: google.maps.Data.FeatureOptions = {
			geometry: KnownLocationPoint,
			properties: {
				Type: "KnownLocation",
				TextColor: this.LocationTextColor,
				Label: NextLabel,
				BusID: BusInfo.BusID,
				BusNbr: BusInfo.BusNbr,
				BusDesc: BusInfo.BusDesc,
				BusLocationLogID: PositionInfo.BusLocationLogID,
				Driver_PersonID: PositionInfo.Driver_PersonID,
				DriverName: PositionInfo.DriverName,
				BusRouteDesc: PositionInfo.BusRouteDesc,
				BusRouteTypeDesc: PositionInfo.BusRouteTypeDesc,
				Lat: PositionInfo.Lat,
				Long: PositionInfo.Long,
				HorizontalAccuracy: PositionInfo.HorizontalAccuracy,
				AccuracyColor: this.GetHeatmapNumber(PositionInfo.HorizontalAccuracy),
				ShowAccuracyColor: this.ShowAccuracyColor,
				SpeedMph: PositionInfo.SpeedMph,
				c_date: PositionInfo.c_date,
				c_dateDesc: PositionInfo.c_dateDesc,
				Selected: false,
			},
		};

		let LocationFeature: google.maps.Data.Feature = new google.maps.Data.Feature(KnownLocationFeatureOptions);
		this.mapRef.map.data.add(LocationFeature);
	}

	RemoveMarker(BusLocationLogID) {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "KnownLocation") {
					if (element.getProperty("BusLocationLogID") == BusLocationLogID) {
						this.mapRef.map.data.remove(element);
						return;
					}
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region Draw Path
	///////////////////////////

	UpdatePath(
		BusID: number,
		First_BusLocationLogID: number,
		Second_BusLocationLogID: number,
		index: number,
		Lat1: number,
		Long1: number,
		Lat2: number,
		Long2: number
	) {
		if (this.ShowBusPath == false) {
			return;
		}

		if (this.HideUnselected == true && this.BusSelected(BusID) == false) {
			return;
		}

		var exists: boolean = false;

		this.mapRef.map.data.forEach((element) => {
			if (element.getProperty("Type") == "Path") {
				if (
					element.getProperty("First_BusLocationLogID") == First_BusLocationLogID &&
					element.getProperty("Second_BusLocationLogID") == Second_BusLocationLogID
				) {
					element.setProperty("Lat2", Lat2);
					element.setProperty("Long2", Long2);

					element.setGeometry(
						new google.maps.Data.LineString([new google.maps.LatLng({ lat: Lat1, lng: Long1 }), new google.maps.LatLng({ lat: Lat2, lng: Long2 })])
					);

					exists = true;
				}
			}
		});

		if (!exists) {
			this.DrawPath(BusID, First_BusLocationLogID, Second_BusLocationLogID, index, Lat1, Long1, Lat2, Long2);
		}
	}

	DrawPath(
		BusID: number,
		First_BusLocationLogID: number,
		Second_BusLocationLogID: number,
		index: number,
		Lat1: number,
		Long1: number,
		Lat2: number,
		Long2: number
	) {
		if (this.ShowBusPath == false) {
			return;
		}

		if (this.HideUnselected == true && this.BusSelected(BusID) == false) {
			return;
		}

		var nextColor: any = this.lstRouteColors[index % this.lstRouteColors.length];

		let LatLong1: google.maps.LatLng = new google.maps.LatLng(Lat1, Long1);
		let LatLong2: google.maps.LatLng = new google.maps.LatLng(Lat2, Long2);
		let PathLine: google.maps.Data.LineString = new google.maps.Data.LineString([LatLong1, LatLong2]);

		let PathFeatureOptions: google.maps.Data.FeatureOptions = {
			geometry: PathLine,
			properties: {
				Type: "Path",
				Color: nextColor,
				BusID: BusID,
				First_BusLocationLogID: First_BusLocationLogID,
				Second_BusLocationLogID: Second_BusLocationLogID,
				Lat1: Lat1,
				Long1: Long1,
				Lat2: Lat2,
				Long2: Long2,
			},
		};

		let PathFeature: google.maps.Data.Feature = new google.maps.Data.Feature(PathFeatureOptions);
		this.mapRef.map.data.add(PathFeature);
	}

	DeletePathBetween(First_BusLocationLogID: number, Second_BusLocationLogID: number) {
		this.mapRef.map.data.forEach((element) => {
			if (element.getProperty("Type") == "Path") {
				if (
					// Delete the pair that is supposed to get deleted
					(element.getProperty("First_BusLocationLogID") == First_BusLocationLogID &&
						element.getProperty("Second_BusLocationLogID") == Second_BusLocationLogID) ||
					// Going in reverse, delete paths that still exist but shouldn't
					(element.getProperty("BusID") == BusModifyComponent && //Sanity Check? Shouldn't matter what the Bus ID is?
						element.getProperty("First_BusLocationLogID") > Second_BusLocationLogID)
				) {
					this.mapRef.map.data.remove(element);
				}
			}
		});
	}

	DeleteAllPathsForBus(BusID: number) {
		this.mapRef.map.data.forEach((element) => {
			if (element.getProperty("Type") == "Path") {
				if (element.getProperty("BusID") == BusID) {
					this.mapRef.map.data.remove(element);
				}
			}
		});
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region Draw Students
	///////////////////////////

	DrawStudentMarker(StudentInfo) {
		var AlreadyExists: any = false;

		this.mapRef.map.data.forEach((element) => {
			try {
				var ID: number = element.getProperty("BusStudentRideTxnID");
				if (ID == StudentInfo.BusStudentRideTxnID) {
					AlreadyExists = true;
				}
			} catch (e) {
				e.toString();
			}
		});

		if (AlreadyExists == true) {
			return;
		}

		this.mapRef.map.data.forEach((element) => {
			if (element.getProperty("Type") == "Bus") {
				if (element.getProperty("BusID") == StudentInfo.BusID) {
					//
					// Add student
					//
					if (StudentInfo.EntryTypeID == 1) {
						var studentCount = element.getProperty("StudentCount");
						var lstStudents = element.getProperty("lstStudentsOnBus");
						var newEntry: any = {
							PersonID: StudentInfo.Student_PersonID,
							StudentID: StudentInfo.StudentID,
							StudentName: StudentInfo.StudentName,
							AssignedRoute: StudentInfo.AssignedRoute,
						};

						element.setProperty("StudentCount", studentCount + 1);
						element.setProperty("lstStudentsOnBus", [...lstStudents, newEntry]);
					}
					//
					// Remove Student
					//
					else if (StudentInfo.EntryTypeID == 2) {
						var studentCount = element.getProperty("StudentCount");
						var lstStudents = element.getProperty("lstStudentsOnBus");

						lstStudents = lstStudents.filter((student) => student.PersonID != StudentInfo.Student_PersonID);

						element.setProperty("StudentCount", studentCount - 1);
						element.setProperty("lstStudentsOnBus", lstStudents);
					}
				}
			}
		});

		//Don't draw positions that are being hidden (But add blank data to bus's list of students. Bus got a blank student at x time)
		if (StudentInfo.IsHidden == true) {
			return;
		}

		if (this.ShowStudentsSwipeOn == false && StudentInfo.EntryTypeID == 1) {
			return;
		}
		if (this.ShowStudentSwipeOff == false && StudentInfo.EntryTypeID == 2) {
			return;
		}

		//
		// Check School Option
		//
		if (this.StudentSchoolOptionID == 1 && StudentInfo.IsMySchool == false) {
			return;
		} else if (this.StudentSchoolOptionID == 2 && StudentInfo.SchoolID != this.StudentSchoolID) {
			return;
		}

		var ManuallySelected = false;
		for (var z = 0; z < this.lstSelectedStudents.length; z++) {
			var next = this.lstSelectedStudents[z];

			if (next.Student_PersonID == StudentInfo.Student_PersonID) {
				ManuallySelected = true;
				break;
			}
		}

		var FromSelector = false;
		// if(AlreadySelected == false && this.ShowSideBar == true){
		if (ManuallySelected == false) {
			for (var z = 0; z < this.StudentsFromSelector.length; z++) {
				var next = this.StudentsFromSelector[z];

				if (StudentInfo.Student_PersonID == next) {
					FromSelector = true;
					break;
				}
			}
		}

		//
		// Select all stops when a bus is selected
		// (From Bus Search only. If using Student search highlight only the selected student's stops and the bus)
		//
		var FromBusSelector = false;

		if (ManuallySelected == false && FromSelector == false && this.StudentsFromSelector.length == 0) {
			FromBusSelector = this.BusSelected(StudentInfo.BusID);
		}

		// if(this.HideUnselected == true && this.BusSelected(StudentInfo.BusID) == false){
		//   return;
		// }

		// if(this.BusSelected(StudentInfo.BusID)){
		//   console.log(StudentInfo);
		//   console.log(FromSelector);
		//   console.log(ManuallySelected);
		//   console.log(FromBusSelector);
		// }

		if (this.HideUnselected == true && FromSelector == false && ManuallySelected == false && FromBusSelector == false) {
			return;
		}

		let NextLabel: any = "";

		if (this.ShowStudentName == true) {
			NextLabel += StudentInfo.StudentName + " ";
		}
		if (this.ShowStudentID == true) {
			NextLabel += "(" + StudentInfo.StudentID + ") ";
		}
		if (this.ShowStudentBus == true) {
			NextLabel += "(" + StudentInfo.BusNbr + ") ";
		}
		if (this.ShowStudentScanTime == true) {
			NextLabel += "(" + StudentInfo.c_dateDesc + ") ";
		}
		if (this.ShowScheduledRider == true) {
			NextLabel += "(" + StudentInfo.isScheduledRiderDesc + ") ";
		}

		let StudentLocation: google.maps.LatLng = new google.maps.LatLng(StudentInfo.Lat, StudentInfo.Long);
		let StudentPoint: google.maps.Data.Point = new google.maps.Data.Point(StudentLocation);
		let StudentFeatureOptions: google.maps.Data.FeatureOptions = {
			geometry: StudentPoint,
			properties: {
				Type: "Student",
				BusStudentRideTxnID: StudentInfo.BusStudentRideTxnID,
				StudentTextColor: this.StudentTextColor,
				StudentLabel: NextLabel,
				DriverName: StudentInfo.DriverName,
				Student_PersonID: StudentInfo.Student_PersonID,
				StudentID: StudentInfo.StudentID,
				StudentName: StudentInfo.StudentName,
				BusID: StudentInfo.BusID,
				BusNbr: StudentInfo.BusNbr,
				BusDesc: StudentInfo.BusDesc,
				BusRouteDesc: StudentInfo.BusRouteDesc,
				EntryTypeID: StudentInfo.EntryTypeID,
				EntryTypeDesc: StudentInfo.EntryTypeDesc,
				Lat: StudentInfo.Lat,
				Long: StudentInfo.Long,
				HorizontalAccuracy: StudentInfo.HorizontalAccuracy,
				c_date: StudentInfo.c_date,
				c_dateDesc: StudentInfo.c_dateDesc,
				AssignedRoute: StudentInfo.AssignedRoute,
				isScheduledRiderDesc: StudentInfo.isScheduledRiderDesc,
				Selected: FromSelector || ManuallySelected, //|| FromBusSelector
				ScanTypeDesc: StudentInfo.ScanTypeDesc,
			},
		};

		let StudentFeature: google.maps.Data.Feature = new google.maps.Data.Feature(StudentFeatureOptions);
		this.mapRef.map.data.add(StudentFeature);
	}

	RemoveStudent(BusStudentRideTxnID) {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Student") {
					if (element.getProperty("BusStudentRideTxnID") == BusStudentRideTxnID) {
						this.mapRef.map.data.remove(element);
					}
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	RemoveStudentsOn() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Student") {
					if (element.getProperty("EntryTypeID") == 1) {
						this.mapRef.map.data.remove(element);
					}
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	RemoveStudentsOff() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "Student") {
					if (element.getProperty("EntryTypeID") == 2) {
						this.mapRef.map.data.remove(element);
					}
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region Draw Geo Fence
	///////////////////////////

	DrawGeoFences() {
		this.UpdateMapStylesAndListeners();

		if (this.ShowGeoFences == false) {
			return;
		}
		for (var i = 0; i < this.lstGeoFence.length; i++) {
			var GeoFenceInfo = this.lstGeoFence[i];

			//
			// Check Active
			//
			if (GeoFenceInfo.Active == true || this.HideInactiveGeoFences == false) {
				//
				// Check if the fence already exists
				//
				var Exists: any = false;
				this.mapRef.map.data.forEach((element) => {
					try {
						if (element.getProperty("Type") == "GeoFence" && element.getProperty("GeoFenceID") == GeoFenceInfo.GeoFenceID) {
							Exists = true;
						}
					} catch (e) {
						e.toString();
					}
				});

				if (!Exists) {
					var lstLatLong: google.maps.LatLng[] = [];

					for (var z = 0; z < GeoFenceInfo.lstPoints.length; z++) {
						var next = GeoFenceInfo.lstPoints[z];

						lstLatLong = [
							...lstLatLong,
							new google.maps.LatLng({
								lat: next.Lat,
								lng: next.Long,
							}),
						];
					}

					let FencePolygon: google.maps.Data.Polygon = new google.maps.Data.Polygon([lstLatLong]);

					let FenceFeatureOptions: google.maps.Data.FeatureOptions = {
						geometry: FencePolygon,
						properties: {
							Type: "GeoFence",
							GeoFenceID: GeoFenceInfo.GeoFenceID,
							GeoFenceDesc: GeoFenceInfo.GeoFenceDesc,
							BusDesc: GeoFenceInfo.BusDesc,
							FillColor: GeoFenceInfo.FillColor,
							AlphaChannel: GeoFenceInfo.AlphaChannel,
							BusID: GeoFenceInfo.BusID,
							GeofenceTriggerTypeID: GeoFenceInfo.GeofenceTriggerTypeID,
							GeofenceTriggerTypeCD: GeoFenceInfo.GeofenceTriggerTypeCD,
							GeofenceTriggerTypeDesc: GeoFenceInfo.GeofenceTriggerTypeDesc,
							Severity: GeoFenceInfo.Severity,
							SeverityDesc: GeoFenceInfo.SeverityDesc,
							AlertComments: GeoFenceInfo.AlertComments,
							Active: GeoFenceInfo.Active,
							ActiveDesc: GeoFenceInfo.ActiveDesc,
							Lat: GeoFenceInfo.MidPointLat,
							Long: GeoFenceInfo.MidPointLong,
							lstPoints: GeoFenceInfo.lstPoints,
							Selected: false,
						},
					};

					let FenceFeature: google.maps.Data.Feature = new google.maps.Data.Feature(FenceFeatureOptions);
					this.mapRef.map.data.add(FenceFeature);
				}
			}
		}
	}

	ClearInactiveGeoFences() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "GeoFence" && element.getProperty("Active") == false) {
					this.mapRef.map.data.remove(element);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	ClearAllGeoFences() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "GeoFence") {
					this.mapRef.map.data.remove(element);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region Clear All
	///////////////////////////

	ClearAll() {
		this.overlays = [];

		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") != "GeoFence") {
					this.mapRef.map.data.remove(element);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region Update Labels
	///////////////////////////

	UpdateLabels() {
		this.mapRef.map.data.forEach((element) => {
			try {
				if (element.getProperty("Type") == "KnownLocation") {
					let NextLabel: any = "";

					if (this.KnownLocationShowBusNbr == true) {
						NextLabel += element.getProperty("BusNbr") + " ";
					}
					if (this.KnownLocationShowCDate == true) {
						NextLabel += "(" + element.getProperty("c_dateDesc") + ") ";
					}
					if (this.KnownLocationShowSpeed == true) {
						NextLabel += "(" + element.getProperty("SpeedMph") + " mph) ";
					}
					if (this.KnownLocationShowLatLong == true) {
						NextLabel += "(" + element.getProperty("Lat") + ", " + element.getProperty("Long") + ") ";
					}
					if (this.KnownLocationShowDriver == true) {
						NextLabel += "(" + element.getProperty("DriverName") + ") ";
					}

					element.setProperty("TextColor", this.LocationTextColor);
					element.setProperty("Label", NextLabel);
					element.setProperty("ShowAccuracyColor", this.ShowAccuracyColor);

					var HorizontalAccuracy = Number(element.getProperty("HorizontalAccuracy"));
					element.setProperty("AccuracyColor", this.GetHeatmapNumber(HorizontalAccuracy));
				} else if (element.getProperty("Type") == "Bus") {
					let NextLabel: any = "";

					if (this.BusShowBusNbr == true) {
						NextLabel += element.getProperty("BusNbr") + " ";
					}
					if (this.BusShowAlertDesc == true && element.getProperty("HasAlert") == true) {
						NextLabel += "(" + element.getProperty("AlertDesc") + ") ";
					}
					if (this.BusShowBusDriver == true) {
						NextLabel += "(" + element.getProperty("DriverName") + ") ";
					}
					if (this.BusShowCurrentRoute == true) {
						NextLabel += "(" + element.getProperty("BusRouteDesc") + ") ";
					}
					if (this.BusShowRouteType == true) {
						NextLabel += "(" + element.getProperty("BusRouteTypeDesc") + ") ";
					}

					element.setProperty("BusTextColor", this.BusTextColor);
					element.setProperty("BusLabel", NextLabel);
				} else if (element.getProperty("Type") == "Student") {
					let NextLabel: any = "";

					if (this.ShowStudentName == true) {
						NextLabel += element.getProperty("StudentName") + " ";
					}
					if (this.ShowStudentID == true) {
						NextLabel += "(" + element.getProperty("StudentID") + ") ";
					}
					if (this.ShowStudentBus == true) {
						NextLabel += "(" + element.getProperty("BusNbr") + ") ";
					}
					if (this.ShowStudentScanTime == true) {
						NextLabel += "(" + element.getProperty("c_dateDesc") + ") ";
					}
					if (this.ShowScheduledRider == true) {
						NextLabel += "(" + element.getProperty("isScheduledRiderDesc") + ") ";
					}

					element.setProperty("StudentTextColor", this.StudentTextColor);
					element.setProperty("StudentLabel", NextLabel);
				}
			} catch (e) {
				e.toString();
			}
		});
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region Update Styles and Listeners
	///////////////////////////
	UpdateMapStylesAndListeners() {
		//
		// Only Run 1 time
		//
		if (this.InitStylesAndListeners == true) {
			return;
		}

		this.InitStylesAndListeners = true;

		/////////////////////////////////////////////////////
		// Styling
		/////////////////////////////////////////////////////

		this.mapRef.map.data.setStyle(function (feature) {
			var Type = feature.getProperty("Type");

			var ParentPath: any = "assets/images/BusTrackerMap/BusIconsV4/";
			
			if (Type == "Bus") {
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("BusLabel");
				// var NextColor: any = "Black";
				var NextColor: any = feature.getProperty("BusTextColor");

				// if(feature.getProperty('HasAlert') == true || feature.getProperty('ShowSpeedWarning') == true){
				if (feature.getProperty("HasAlert") == true) {
					NextColor = "Red";
				}

				nextLabel = {
					text: NextText,
					color: NextColor,
					fontWeight: "Bold",
				};

				var iconPath: any = "";
				var Severity: any = Number(feature.getProperty("Severity"));
				var Selected: any = feature.getProperty("Selected");

				iconPath = ParentPath + "Bus_Default.png";

				if (Severity == 0) {
					if (Selected) {
						iconPath = ParentPath + "Bus_DefaultSelected.png";
					} else {
						iconPath = ParentPath + "Bus_Default.png";
					}
				} else if (Severity == 3) {
					if (Selected) {
						iconPath = ParentPath + "Bus_LowAlertSelected.png";
					} else {
						iconPath = ParentPath + "Bus_LowAlert.png";
					}
				} else if (Severity == 2) {
					if (Selected) {
						iconPath = ParentPath + "Bus_MediumAlertSelected.png";
					} else {
						iconPath = ParentPath + "Bus_MediumAlert.png";
					}
				} else if (Severity == 1) {
					if (Selected) {
						iconPath = ParentPath + "Bus_HighAlertSelected.png";
					} else {
						iconPath = ParentPath + "Bus_HighAlert.png";
					}
				}

				if (NextText != "") {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 25,
								y: 60,
							},
						},
						label: nextLabel,
						title: feature.getProperty("BusNbr"),
					};
				} else {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 25,
								y: 60,
							},
						},
						title: feature.getProperty("BusNbr"),
					};
				}
			} else if (Type == "Student") {
				var iconPath: any = "/assets/images/BusTrackerMap/student_icon.png";
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("StudentLabel");
				var NextColor: any = feature.getProperty("StudentTextColor");

				var EntryTypeID = feature.getProperty("EntryTypeID");
				var Selected = feature.getProperty("Selected");

				if (EntryTypeID == 1) {
					if (Selected) {
						iconPath = ParentPath + "StudentOnSelected.png";
					} else {
						iconPath = ParentPath + "StudentOn.png";
					}
				} else if (EntryTypeID == 2) {
					if (Selected) {
						iconPath = ParentPath + "StudentOffSelected.png";
					} else {
						iconPath = ParentPath + "StudentOff.png";
					}
				}

				if (feature.getProperty("LastTransaction") == true) {
					NextText += "*";
				}

				nextLabel = {
					text: NextText,
					color: NextColor,
					fontWeight: "Bold",
				};

				if (NextText != "") {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 17.5,
								y: -10,
							},
						},
						label: nextLabel,
						title: feature.getProperty("StudentName"),
					};
				} else {
					return {
						icon: {
							url: iconPath,
							labelOrigin: {
								x: 17.5,
								y: -10,
							},
						},
						title: feature.getProperty("StudentName"),
					};
				}
			} else if (Type == "GeoFence") {
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("Label");

				nextLabel = {
					text: NextText,
					color: "Black", //NextColor,
					fontWeight: "Bold",
				};

				var NextStrokeColor: any = "Black";
				var NextStrokeWeight: any = 1;

				if (feature.getProperty("Selected") == true) {
					NextStrokeColor = "Blue";
					NextStrokeWeight = 4;
				}

				if (NextText != "") {
					return {
						label: nextLabel,
						title: feature.getProperty("GeoFenceID"),
						strokeOpacity: 0.5,
						strokeColor: NextStrokeColor,
						strokeWeight: NextStrokeWeight,
						fillColor: feature.getProperty("FillColor"),
						fillOpacity: feature.getProperty("AlphaChannel"),
					};
				} else {
					return {
						title: feature.getProperty("GeoFenceID"),
						strokeOpacity: 0.5,
						strokeColor: NextStrokeColor,
						strokeWeight: NextStrokeWeight,
						fillColor: feature.getProperty("FillColor"),
						fillOpacity: feature.getProperty("AlphaChannel"),
					};
				}
			} else if (Type == "KnownLocation") {
				let nextLabel: google.maps.MarkerLabel = null;

				var NextText: any = feature.getProperty("Label");
				var NextColor: any = feature.getProperty("TextColor");

				nextLabel = {
					text: NextText,
					color: NextColor,
					fontWeight: "Bold",
				};

				var iconPath: any = "";

				let iconOrigin: google.maps.Point = new google.maps.Point(0, 0);
				let iconSize: google.maps.Size = new google.maps.Size(25, 25);

				var Selected: any = feature.getProperty("Selected");
				var ShowAccuracyColor: any = feature.getProperty("ShowAccuracyColor");

				if (Selected) {
					if (ShowAccuracyColor == true) {
						iconPath = ParentPath + "KnownLocation_SelectedSpriteSheet.png";
					} else {
						iconPath = ParentPath + "KnownLocation_Selected.png";
					}
				} else {
					if (ShowAccuracyColor == true) {
						iconPath = ParentPath + "KnownLocation_UnselectedSpriteSheet.png";
					} else {
						iconPath = ParentPath + "KnownLocation_Unselected.png";
					}
				}

				if (ShowAccuracyColor == true) {
					var ColorNum = feature.getProperty("AccuracyColor");

					var col = 0;
					var row = 0;

					//
					// Grid
					// 0,	>5,		>10,	>15,	>20		(Row 0)
					// >25,	>30		>35,	>40,	>45		(Row 1)
					// .
					// >75,	>80,	>85,	>90,	>95		(Row 3)
					//

					row = Math.floor(ColorNum / 25);
					col = Math.floor((ColorNum - row * 25) / 5);

					if (row > 3) {
						row = 3;
						col = 4;
					}

					iconOrigin = new google.maps.Point(col * 25, row * 25);
				}

				if (NextText != "") {
					return {
						icon: {
							url: iconPath,
							origin: iconOrigin,
							size: iconSize,
							labelOrigin: {
								x: 10,
								y: 30,
							},
							anchor: {
								x: 12.5,
								y: 12.5,
							},
						},
						label: nextLabel,
						title: feature.getProperty("BusNbr") + " " + feature.getProperty("c_dateDesc"),
					};
				} else {
					return {
						icon: {
							url: iconPath,
							origin: iconOrigin,
							size: iconSize,
							labelOrigin: {
								x: 10,
								y: 30,
							},
							anchor: {
								x: 12.5,
								y: 12.5,
							},
						},
						title: feature.getProperty("BusNbr") + " " + feature.getProperty("c_dateDesc"),
					};
				}
			} else if (Type == "Path") {
				return {
					strokeColor: feature.getProperty("Color"),
					strokeOpacity: 1,
				};
			}
		});

		/////////////////////////////////////////////////////

		/////////////////////////////////////////////////////
		// Event Listeners
		/////////////////////////////////////////////////////

		this.mapRef.map.data.addListener("rightclick", (event) => {
			/////////////////////////////////////////////////////////////////////////////////////////////////////
			// Open Info Window
			/////////////////////////////////////////////////////////////////////////////////////////////////////

			let infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow();

			var type: any = event.feature.getProperty("Type");

			var latLng: google.maps.LatLng;

			if (type == "Bus") {
				infoWindow.setContent(this.GetBusPopup(event.feature, infoWindow));
				latLng = new google.maps.LatLng({
					lat: event.feature.getProperty("Lat"),
					lng: event.feature.getProperty("Long"),
				});
			} else if (type == "Student") {
				infoWindow.setContent(this.GetStudentPopup(event.feature, infoWindow));

				//
				// If spiderfied, display window near new position
				//
				var Point: google.maps.Data.Point = event.feature.getGeometry();
				var latLng: google.maps.LatLng = Point.get();
			} else if (type == "GeoFence") {
				infoWindow.setContent(this.GetGeoFencePopup(event.feature));
				latLng = new google.maps.LatLng({
					lat: event.feature.getProperty("Lat"),
					lng: event.feature.getProperty("Long"),
				});
			} else if (type == "KnownLocation") {
				infoWindow.setContent(this.GetKnownLocationPopup(event.feature));
				latLng = new google.maps.LatLng({
					lat: event.feature.getProperty("Lat"),
					lng: event.feature.getProperty("Long"),
				});
			}

			infoWindow.setOptions({
				// position: { lat: event.feature.getProperty("Lat"), lng: event.feature.getProperty("Long") }
				position: latLng,
			});

			infoWindow.open(this.mapRef.map);

			/////////////////////////////////////////////////////////////////////////////////////////////////////
		});

		this.mapRef.map.data.addListener("click", (event) => {
			//
			// Check if student
			//
			if (event.feature.getProperty("Type") == "Student") {
				//
				// First Check if it is overlapping other students
				//

				var Overlap: any = false;
				for (var z = 0; z < this.lstOverlaps.length; z++) {
					var next = this.lstOverlaps[z];

					if (next.getProperty("BusStudentRideTxnID") == event.feature.getProperty("BusStudentRideTxnID")) {
						Overlap = true;
						break;
					}
				}

				//
				// If overlapping and not spiderfied already
				// then spiderfy
				//
				if (!Overlap && event.feature.getProperty("BusStudentRideTxnID") != this.SpiderfyBusStudentRideTxnID) {
					//
					// Unspiderfy existing web
					//
					if (Number(this.lstOverlaps.length) > 0) {
						this.StudentUnSpiderfy();
					}

					//
					// Update overlap list
					//
					this.SpiderfyUpdateOverlapList(event);

					//
					// If there are overlaps, spiderfy
					//
					if (this.lstOverlaps.length > 0) {
						this.StudentSpiderfy(event);
					}
					//
					// If normal point then select like normal
					//
					else {
						this.SelectStudent(event);
					}
				}
				//
				// Else select or deselect (Point is part of current spider web, either center or expanded point)
				//
				else {
					this.SelectStudent(event);
				}
			}
			//
			// Not student
			//
			else {
				//
				// Close spiderfy if opened
				//
				if (this.lstOverlaps.length > 0) {
					this.StudentUnSpiderfy();
				}

				//
				// Check if other item was clicked on
				//
				if (event.feature.getProperty("Type") == "Bus") {
					/////////////////////////////////////////////////////////////////////////////////////////////////////
					// Select or deselect Bus
					/////////////////////////////////////////////////////////////////////////////////////////////////////

					var tempSelected = event.feature.getProperty("Selected");

					var NewSelected = true;
					if (tempSelected == true) {
						NewSelected = false;
					}

					event.feature.setProperty("Selected", NewSelected);

					var BusID = event.feature.getProperty("BusID");

					if (NewSelected == true) {
						for (var z = 0; z < this.lstBusHistory.length; z++) {
							var next = this.lstBusHistory[z];

							if (next.BusID == BusID) {
								this.lstSelectedBuses = [...this.lstSelectedBuses, next];
								break;
							}
						}

						// this.mapRef.map.setCenter( { lat: event.feature.getProperty("Lat"), lng: event.feature.getProperty("Long") } );
					} else {
						this.lstSelectedBuses = this.lstSelectedBuses.filter((bus) => bus.BusID != BusID);
					}

					/////////////////////////////////////////////////////////////////////////////////////////////////////
				} else if (event.feature.getProperty("Type") == "KnownLocation") {
					var tempSelected = event.feature.getProperty("Selected");

					var NewSelected = true;
					if (tempSelected == true) {
						NewSelected = false;
					}

					event.feature.setProperty("Selected", NewSelected);
				}
			}
		});

		/////////////////////////////////////////////////////

		/////////////////////////////////////////////////////
	}

	InitColors() {
		//
		// Create an RGB color for each bus
		//
		for (var z = 0; z < this.lstBusHistory.length; z++) {
			var RandomColor: number[] = this.GetRandomColor();

			this.lstRouteColors = [...this.lstRouteColors, "rgb(" + RandomColor[0] + "," + RandomColor[1] + "," + RandomColor[2] + ")"];
		}
	}

	GetRandomColor() {
		var r: number = 255;
		var g: number = 255;
		var b: number = 255;

		//
		// Create dark colors that show up on the map
		//
		while (r + g + b > this.RouteColorMaxSum) {
			r = Math.random() * 255;
			g = Math.random() * 255;
			b = Math.random() * 255;
		}

		return [r, g, b];
	}

	GetHeatmapNumber(Accuracy: number): number {
		var ans = 0;

		if (Accuracy > 0 && this.AccuracyFt > 0) {
			var PercentOfMax = Accuracy / this.AccuracyFt;

			if (PercentOfMax > 1) {
				PercentOfMax = 1;
			}

			var ColorNum = PercentOfMax * 100;

			var Interval = 5;
			var Nearest = Math.round((ColorNum + Interval / 2) / Interval) * Interval;
			ans = Nearest;
		}

		return ans;
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region Popups
	///////////////////////////
	GetBusPopup(BusFeature, infoWindow) {
		//Start loading photo and update when it's done
		this.LoadBusStudentPhotos(BusFeature, infoWindow);

		//Return popup with loading message
		return this.BusStudentListImageLoading(BusFeature);
	}

	LoadBusStudentPhotos(BusFeature, infoWindow) {
		var lstPIDs: number[] = [];

		var lstStudents = BusFeature.getProperty("lstStudentsOnBus");

		for (var z = 0; z < lstStudents.length; z++) {
			var next = lstStudents[z];

			lstPIDs = [...lstPIDs, next.PersonID];
		}

		var parms: BTBusGetPersonPhotosRequest = {
			lstPersonIDs: lstPIDs,
		};

		var result = this.busService.BusGetPersonPhotos(parms);
		result.subscribe(
			(response) => {
				//
				// Update window when the person images have loaded
				//
				infoWindow.setContent(this.BusStudentList(response, BusFeature));
			},
			(error) => {}
		);
	}

	GetBusPopupMain(BusFeature) {
		var htmlText: any = "";

		//
		// Main Info
		//
		htmlText +=
			`
      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
        
        <h4 style="grid-column: 1 / 3; text-align: center; margin-top: -5px; margin-bottom: -5px;">Bus:</h4>
    
        <label style="margin: 0px;">Bus Number:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusNbr") +
			`</p>

        <label style="margin: 0px;">Bus Description:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Driver:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("DriverName") +
			`</p>

        <label style="margin: 0px;">Current Route:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusRouteDesc") +
			`</p>

        <label style="margin: 0px;">Current Route Type:</label>
        <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("BusRouteTypeDesc") +
			`</p>`;

		if (BusFeature.getProperty("Approx") == false) {
			htmlText +=
				`<label style="margin: 0px;">Latitude:</label>
        <p style="margin: 0px; color: blue;">` +
				BusFeature.getProperty("Lat") +
				`</p>

        <label style="margin: 0px;">Longitude:</label>
        <p style="margin: 0px; color: blue;">` +
				BusFeature.getProperty("Long") +
				`</p>
        
        <label style="margin: 0px;">Accuracy (ft, lower is better):</label>
        <p style="margin: 0px; color: blue;">` +
				BusFeature.getProperty("HorizontalAccuracy") +
				`</p>`;
		} else {
			htmlText +=
				`<label style="margin: 0px;">Approx. Latitude:</label>
      <p style="margin: 0px; color: blue;">` +
				BusFeature.getProperty("Lat") +
				`</p>

      <label style="margin: 0px;">Approx. Longitude:</label>
      <p style="margin: 0px; color: blue;">` +
				BusFeature.getProperty("Long") +
				`</p>`;
		}

		if (BusFeature.getProperty("HasAlert") == true) {
			htmlText +=
				`
        <label style="margin: 0px;">Current Alert:</label>
        <p style="margin: 0px; color: Red;">` +
				BusFeature.getProperty("AlertDesc") +
				`</p>
      `;
		}

		htmlText +=
			`
      <label style="margin: 0px;">Student Count:</label>
      <p style="margin: 0px; color: blue;">` +
			BusFeature.getProperty("StudentCount") +
			`</p>

      </div>
    `;

		return htmlText;
	}

	//
	// Student list while the images are still loading
	//
	BusStudentListImageLoading(BusFeature) {
		var htmlText: any = "";

		//
		// Get main body
		//
		htmlText = this.GetBusPopupMain(BusFeature);

		//
		// List of Students
		//
		if (BusFeature.getProperty("StudentCount") > 0) {
			htmlText += `
        <style>
          table {
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 8px;
          }

          tr:nth-child(even) {
            background-color: #dddddd;
          }
        </style>

        <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
          <label>Students on Bus:</label>
          <table>
            <tr>
              <th>Photo</th>
              <th>Student ID</th>
              <th>Name</th>
            </tr>`;

			//
			// Add a row for each student in the list
			//
			var lstStudents = BusFeature.getProperty("lstStudentsOnBus");
			for (var z = 0; z < lstStudents.length; z++) {
				var next = lstStudents[z];

				htmlText +=
					`
          <tr` +
					(next.AssignedRoute == false ? ` style="color: Red;"` : ``) +
					`>
            <td>...Image Loading</td>
            <td>` +
					next.StudentID +
					`</td>
            <td>` +
					next.StudentName +
					(next.AssignedRoute == false ? ` <span style="color: Red;">*</span>` : ``) +
					`</td>
          </tr>
        `;
			}

			htmlText += `
          </table>
        </div>
      `;
		}

		// if(BusFeature.getProperty("ToPickupCount") > 0){

		//   htmlText += `
		//     <style>
		//       table {
		//         font-family: arial, sans-serif;
		//         border-collapse: collapse;
		//         width: 100%;
		//       }

		//       td, th {
		//         border: 1px solid #dddddd;
		//         text-align: left;
		//         padding: 8px;
		//       }

		//       tr:nth-child(even) {
		//         background-color: #dddddd;
		//       }
		//     </style>

		//     <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
		//       <label>Students Assigned Route <span style="color: Red;">(NOT ON BUS)</span>:</label>
		//       <table>
		//         <tr>
		//           <th>Student ID</th>
		//           <th>Name</th>
		//         </tr>`;

		//   //
		//   // Add a row for each student in the list
		//   //
		//   var lstToPickUp = BusFeature.getProperty("lstStudentsToPickUp");
		//   for(var z = 0; z < lstToPickUp.length; z++){
		//     var next = lstToPickUp[z];

		//     htmlText +=  `
		//       <tr>
		//         <td>` + next.StudentID + `</td>
		//         <td>` + next.StudentName + `</td>
		//       </tr>
		//     `;
		//   }

		//   htmlText +=`
		//       </table>
		//     </div>
		//   `;
		// }

		return htmlText;
	}

	//
	// Student list after the images are loaded
	//
	BusStudentList(lstImages, BusFeature) {
		var htmlText: any = "";

		htmlText = this.GetBusPopupMain(BusFeature);

		//
		// List of Students
		//
		if (BusFeature.getProperty("StudentCount") > 0) {
			htmlText += `
        <style>
          table {
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            border: 1px solid #dddddd;
            text-align: left;
            padding: 8px;
          }

          tr:nth-child(even) {
            background-color: #dddddd;
          }
        </style>

        <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
          <label>Students on Bus:</label>
          <table>
            <tr>
              <th>Photo</th>
              <th>Student ID</th>
              <th>Name</th>
            </tr>`;

			//
			// Add a row for each student in the list
			//
			var lstStudents = BusFeature.getProperty("lstStudentsOnBus");
			for (var z = 0; z < lstStudents.length; z++) {
				var next = lstStudents[z];

				var PersonPhoto = "";
				for (var i = 0; i < lstImages.length; i++) {
					var nextImage = lstImages[i];

					if (nextImage.PersonID == next.PersonID) {
						PersonPhoto = nextImage.PersonPhotoData;
					}
				}

				htmlText +=
					`
          <tr` +
					(next.AssignedRoute == false ? ` style="color: Red;"` : ``) +
					`>
            <td>
              <div style="border: 1px solid black; max-width: 200px; max-height: 200px;">
                <img style="max-width: 200px; max-height: 200px;" src="` +
					PersonPhoto +
					`">
              </div>
            </td>
            <td>` +
					next.StudentID +
					`</td>
            <td>` +
					next.StudentName +
					(next.AssignedRoute == false ? ` <span style="color: Red;">*</span>` : ``) +
					`</td>
          </tr>
        `;
			}

			htmlText += `
          </table>
        </div>
      `;
		}

		// if(BusFeature.getProperty("ToPickupCount") > 0){

		//   htmlText += `
		//     <style>
		//       table {
		//         font-family: arial, sans-serif;
		//         border-collapse: collapse;
		//         width: 100%;
		//       }

		//       td, th {
		//         border: 1px solid #dddddd;
		//         text-align: left;
		//         padding: 8px;
		//       }

		//       tr:nth-child(even) {
		//         background-color: #dddddd;
		//       }
		//     </style>

		//     <div style="margin-top: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; text-align: center;">
		//       <label>Students Assigned Route <span style="color: Red;">(NOT ON BUS)</span>:</label>
		//       <table>
		//         <tr>
		//           <th>Student ID</th>
		//           <th>Name</th>
		//         </tr>`;

		//   //
		//   // Add a row for each student in the list
		//   //
		//   var lstToPickUp = BusFeature.getProperty("lstStudentsToPickUp");
		//   for(var z = 0; z < lstToPickUp.length; z++){
		//     var next = lstToPickUp[z];

		//     htmlText +=  `
		//       <tr>
		//         <td>` + next.StudentID + `</td>
		//         <td>` + next.StudentName + `</td>
		//       </tr>
		//     `;
		//   }

		//   htmlText +=`
		//       </table>
		//     </div>
		//   `;
		// }

		return htmlText;
	}

	GetStudentPopup(StudentFeature, infoWindow): string {
		this.LoadStudentPhoto(StudentFeature, infoWindow);

		return this.FinishGetStudentPopupImageLoading(StudentFeature);
	}

	LoadStudentPhoto(StudentFeature, infoWindow): string {
		var result = this.busService.PersonGetImage(StudentFeature.getProperty("Student_PersonID"));
		result.subscribe(
			(response) => {
				var img = response[0];

				infoWindow.setContent(this.FinishGetStudentPopup(StudentFeature, img));
			},
			(error) => {}
		);

		return "";
	}

	FinishGetStudentPopupImageLoading(StudentFeature) {
		var htmlText: any = "";

		htmlText += `
      <div style="text-align: center; width: fit-content; margin-left: auto; margin-right: auto;">
        <label style="margin-bottom: 10px;">...Image Loading</label>
      </div>
    `;

		return this.FinishGetPopupMain(StudentFeature, htmlText);
	}

	FinishGetStudentPopup(StudentFeature, img) {
		var htmlText: any = "";

		htmlText +=
			`
      <div style="text-align: center; width: fit-content; margin-left: auto; margin-right: auto;">
        <div style="border: 1px solid black; max-width: 200px; max-height: 200px; margin-bottom: 10px;">
          <img style="max-width: 200px; max-height: 200px;" src="` +
			img +
			`">
        </div>
      </div>
    `;

		return this.FinishGetPopupMain(StudentFeature, htmlText);
	}

	FinishGetPopupMain(StudentFeature, htmlText) {
		//
		// Main Info
		//
		htmlText +=
			`
      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
      
        <h4 style="grid-column: 1 / 3; text-align: center; margin-top: -5px; margin-bottom: -5px;">Student:</h4>

        <label style="margin: 0px;">Student ID:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("StudentID") +
			`</p>

        <label style="margin: 0px;">Student Name:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("StudentName") +
			`</p>
        
        <label style="margin: 0px;">Bus Number:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("BusNbr") +
			`</p>

        <label style="margin: 0px;">Bus Description:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Driver:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("DriverName") +
			`</p>

        <label style="margin: 0px;">Route Description:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("BusRouteDesc") +
			`</p>

        <label style="margin: 0px;">Entry/Exit Type:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("EntryTypeDesc") +
			`</p>

        <label style="margin: 0px;">Scan Time:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("c_dateDesc") +
			`</p>

        <label style="margin: 0px;">Lat:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("Lat") +
			`</p>

        <label style="margin: 0px;">Long:</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("Long") +
			`</p>

        <label style="margin: 0px;">Accuracy (ft, less is better):</label>
        <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("HorizontalAccuracy") +
			`</p>`;

		htmlText += `<label style="margin: 0px;">Scheduled Rider:</label>`;

		if (StudentFeature.getProperty("AssignedRoute") == true) {
			htmlText += `<p style="margin: 0px; color: Blue;">Yes</p>`;
		} else {
			htmlText += `<p style="margin: 0px; color: Red;">No (added manually)</p>`;
		}

		htmlText +=
			`        
          <label style="margin: 0px;">Scan Type:</label>
          <p style="margin: 0px; color: blue;">` +
			StudentFeature.getProperty("ScanTypeDesc") +
			`</p>`;

		htmlText += `</div>`;

		return htmlText;
	}

	GetGeoFencePopup(GeoFenceInfo) {
		var htmlText: any = "";

		htmlText +=
			`
      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
      
        <h4 style="grid-column: 1 / 3; text-align: center; margin-top: -5px; margin-bottom: -5px;">Geo Fence:</h4>

        <label style="margin: 0px;">Description:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeoFenceDesc") +
			`</p>

        <label style="margin: 0px;">Used By:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Trigger Type Code:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeofenceTriggerTypeCD") +
			`</p>

        <label style="margin: 0px;">Trigger Type Description:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("GeofenceTriggerTypeDesc") +
			`</p>

        <label style="margin: 0px;">Severity:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("SeverityDesc") +
			`</p>

        <label style="margin: 0px;">Comments:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("AlertComments") +
			`</p>

        <label style="margin: 0px;">Active:</label>
        <p style="margin: 0px; color: blue;">` +
			GeoFenceInfo.getProperty("ActiveDesc") +
			`</p>

      </div>
    `;

		return htmlText;
	}

	GetKnownLocationPopup(LocationInfo) {
		var htmlText: any = "";

		//
		// Main Info
		//
		htmlText +=
			`

      <div style="display: grid; grid-template-columns: auto auto; grid-column-gap: 15px; grid-row-gap: 15px; padding: 15px; border: 2px solid black; border-radius: 15px; align-items: center;">
      
        <h4 style="grid-column: 1 / 3; text-align: center; margin-top: -5px; margin-bottom: -5px;">Known Location:</h4>

        <label style="margin: 0px;">Bus Number:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("BusNbr") +
			`</p>

        <label style="margin: 0px;">Bus Description:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("BusDesc") +
			`</p>

        <label style="margin: 0px;">Driver:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("DriverName") +
			`</p>

        <label style="margin: 0px;">Current Route:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("BusRouteDesc") +
			`</p>
        
        <label style="margin: 0px;">Route Type:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("BusRouteTypeDesc") +
			`</p>

        <label style="margin: 0px;">Speed:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("SpeedMph") +
			`</p>
        
        <label style="margin: 0px;">Date/Time:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("c_dateDesc") +
			`</p>

        <label style="margin: 0px;">Latitude:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("Lat") +
			`</p>

        <label style="margin: 0px;">Longitude:</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("Long") +
			`</p>

        <label style="margin: 0px;">Accuracy (ft, lower is better):</label>
        <p style="margin: 0px; color: blue;">` +
			LocationInfo.getProperty("HorizontalAccuracy") +
			`</p>
      </div>
    `;

		return htmlText;
	}

	//#endregion
	///////////////////////////

	///////////////////////////
	//#region Sounds
	///////////////////////////

	dataURIToMP3Blob(val) {
		const byteString = window.atob(val);
		const arrayBuffer = new ArrayBuffer(byteString.length);
		const int8Array = new Uint8Array(arrayBuffer);
		for (let i = 0; i < byteString.length; i++) {
			int8Array[i] = byteString.charCodeAt(i);
		}
		const blob = new Blob([int8Array], { type: "audio/mpeg" });
		return blob;
	}

	PlayAlertSound(Severity, AlertTypeDesc) {
		// console.log("Play Alert Sound, Severity: " + Severity + ", Alert Type Desc: " + AlertTypeDesc + ", Forwards? " + this.Forwards);

		if (this.PlaySounds == false) {
			return;
		}

		if (this.Forwards == false) {
			return;
		}

		var a = new Audio();
		var src: any = null;

		if (Severity == 1) {
			if (AlertTypeDesc == "Accident (HIGH)") {
				src = this.AccidentHighSound;
			} else {
				src = this.HighSeveritySound;
			}
		} else if (Severity == 2) {
			src = this.MediumSeveritySound;
		} else if (Severity == 3) {
			src = this.LowSeveritySound;
		}

		if (src != null) {
			a.src = src;
			a.cloneNode();
			a.load();
			a.play();
		}
	}

	//#endregion
	///////////////////////////

	//#endregion
	//////////////////////////////////////////////////////////////////////
}
